// Mock data for CXSquare Solutions website - Startup focused

export const companyInfo = {
  name: "CXSquare Solutions",
  product: "GrowSquare",
  tagline: "Smarter Insights. Intelligent Engagement. Stronger Growth.",
  description: "We help businesses connect with customers through AI and automation that handle the busywork, paired with deeper insights that make decision-making easier.",
  email: "hello@cxsquare.com",
  phone: "+1 (555) 123-4567",
  address: "123 Innovation Drive, Tech Valley, CA 94043"
};
export const heroStats = [
  {
    "number": "AI Native",
    "label": "Not Bolted On"
  },
  {
    "number": "30%",
    "label": "Productivity Boost from Day 1"
  },
  {
    "number": "3x",
    "label": "Faster Lead Follow-Up"
  },
  {
    "number": "40%",
    "label": "Less Time on Deal Analysis"
  }
];

export const enterprisePlan = {
  name: "Enterprise Plan",
  subTitle: "Tailored for Large-Scale Operations",
  subTitle1: "Tailored Excellence for Your Organization",
  description: "Our Enterprise Plan offers an isolated sandbox environment with advanced performance, enterprise-grade security, and full customization. Safely test and deploy changes without affecting live data.",
  description1: "Our Enterprise Plan offers an isolated sandbox environment, delivering top performance, enterprise-grade security, and full customization for large-scale operations.",
  contactUs: "Contact our Sales or Support team to explore a custom plan for your organization.",
  contactUs1: "To explore a custom Enterprise Plan, contact our Sales or Support team.",
  buttonText: "Contact Now",
  features: [{ title: "Sandbox Environment", content: " – Secure, isolated setup for testing and deployment" },
  { title: "All Features Included", content: " – Access to every platform capability" },
  { title: "Custom Workflows & Integrations", content: " – Tailored to your business processes" },
  { title: "Dedicated Account Manager", content: " – Expert guidance and personalized support" },
  { title: "Priority Support", content: " – Fast, reliable assistance" },
  { title: "Scalable Solutions", content: " – Grow seamlessly with your business" },
  ]
}
export const crmFeatures = [
  {
    "id": 1,
    "icon": "FeatureIcon1",
    "title": "Customer Intelligence & Engagement",
    "subTitle": "Research target accounts, find the right contacts and keep in touch with them.",
    "description": "GrowSquare helps your team research target accounts, find the right people to speak to, and stay in touch with them until they are ready to talk.",
    "useCaseDescription": "How teams use customer intelligence and automated follow-up to build their pipeline.",
    "benefits": [
      "Customer intelligence collection",
      "Target role identification",
      "Automated lead nurturing"
    ],
    "detailsBenefits": [
      "Prospect details in one profile, ready before the first call",
      "Quicker identification of who is involved in a buying decision",
      "Follow-up sequences that run on schedule",
      "Less time spent on manual research and data entry"
    ],
    "useCase": [
      {
        "title": "Customer Intelligence Collection",
        "description": "Pulls company and contact details from connected sources into one profile",
        "result": "Reps start conversations with context instead of a blank record"
      },
      {
        "title": "Target Role Identification",
        "description": "Suggests likely decision-makers and influencers inside a target account",
        "result": "Helps reps reach the right people earlier in the sale"
      },
      {
        "title": "Automated Lead Nurturing",
        "description": "Sends follow-up emails and reminders based on rules you set",
        "result": "Keeps leads warm without relying on reps to remember each one"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Data Collection",
        "description": "Gather company and contact information into one prospect profile."
      },
      {
        "id": 2,
        "title": "Role Identification",
        "description": "Flag the likely decision-makers and key contacts for each account."
      },
      {
        "id": 3,
        "title": "Nurture Sequences",
        "description": "Send follow-ups on a schedule and log replies against the contact."
      },
      {
        "id": 4,
        "title": "Profile Updates",
        "description": "Keep profiles current as new information comes in."
      }
    ],
    "readyToTitle": "Ready to Try Customer Intelligence & Engagement?",
    "readyToDescription": "See how research and follow-up work together in the product."
  },
  {
    "id": 2,
    "icon": "FeatureIcon2",
    "title": "Intelligent Deal Orchestration",
    "subTitle": "AI recommends the next best step on every deal, from first touch to close.",
    "description": "Every record and interaction across your deals is captured and analysed by AI models, which recommend the next best step. From first touch to close, your team always knows what to do next and why.",
    "useCaseDescription": "See how AI-driven next best steps improve deal velocity and boost close rates.",
    "benefits": [
      "Deal process orchestration",
      "AI-generated win strategies",
      "Genie Sales Bot for questions and priority tasks"
    ],
    "detailsBenefits": [
      "Smarter deal progression with fewer bottlenecks",
      "Data-driven win strategies tailored to each opportunity",
      "Analysis of scores for leads, contacts, deals and accounts, and how to improve them",
      "Consistent deal outcomes and higher win rates"
    ],
    "useCase": [
      {
        "title": "Deal Process Orchestration",
        "description": "Analyses every deal record and interaction to streamline stages and remove bottlenecks",
        "result": "Creates smoother sales journeys and reduces internal friction"
      },
      {
        "title": "AI-Generated Win Strategies",
        "description": "Turns captured deal signals into tailored strategies for each opportunity",
        "result": "Enhances competitiveness and sharpens deal positioning"
      },
      {
        "title": "Genie Sales Bot",
        "description": "Answers any question about your accounts, deals and pipeline in plain language, or gathers your priority tasks",
        "result": "Reps get answers, including cross-sell and upsell ideas, in seconds instead of searching records or waiting on a manager, and know where to focus"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Capture and Analyse",
        "description": "Every record and interaction, historical and current, is captured and analysed by AI models to detect bottlenecks and buying signals."
      },
      {
        "id": 2,
        "title": "AI Playbook Generation",
        "description": "Strategies tailored to each deal are created from what the data shows."
      },
      {
        "id": 3,
        "title": "Next Best Step Recommendations",
        "description": "The AI recommends the most effective action at each stage and triggers follow-ups automatically for consistent execution."
      },
      {
        "id": 4,
        "title": "Ask Genie Sales Bot",
        "description": "Reps ask Genie Sales Bot any question about their accounts, deals or pipeline, including cross-sell and upsell opportunities, or have it gather their priority tasks."
      }
    ],
    "readyToTitle": "Ready to Experience Intelligent Deal Orchestration?",
    "readyToDescription": "See how AI turns every interaction into the next best step, moving deals faster and increasing win rates.",
    "howItWorksIntro": "Our intelligent system works in the background, capturing and analysing every deal signal so you always know the next best step."
  },
  {
    "id": 3,
    "icon": "FeatureIcon3",
    "title": "ML-Powered Insights & Predictions",
    "subTitle": "Scores and alerts based on your own CRM data.",
    "description": "GrowSquare scores leads and deals, flags customers at risk of leaving, and points out opportunities in your data. Scores are based on your own CRM history.",
    "useCaseDescription": "How predictions help teams decide where to spend their time.",
    "benefits": [
      "Predictive lead and deal scoring",
      "Churn risk detection for accounts",
      "Proactive sales insights"
    ],
    "detailsBenefits": [
      "Time spent on the leads and deals most likely to close",
      "Early warning on accounts that may churn",
      "Prompts for upsell and cross-sell opportunities",
      "Insights delivered inside the CRM, where reps already work"
    ],
    "useCase": [
      {
        "title": "Predictive Scoring",
        "description": "Ranks leads and deals by how closely they match past wins",
        "result": "Helps reps decide who to call first"
      },
      {
        "title": "Churn Risk Detection",
        "description": "Flags accounts whose activity, cases or renewals suggest risk",
        "result": "Gives account managers time to step in"
      },
      {
        "title": "Proactive Sales Insights",
        "description": "Highlights accounts that may be ready to buy more",
        "result": "Supports upsell and cross-sell conversations"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Scoring",
        "description": "Rank leads and deals using patterns from your won and lost history."
      },
      {
        "id": 2,
        "title": "Churn Detection",
        "description": "Watch customer activity and cases for signs of risk."
      },
      {
        "id": 3,
        "title": "Insight Delivery",
        "description": "Show recommendations to sales and service teams on the record and in reports."
      }
    ],
    "readyToTitle": "Ready to See Predictions on Your Own Data?",
    "readyToDescription": "We can walk through how scoring and churn alerts would work with your pipeline."
  },
  {
    "id": 4,
    "icon": "FeatureIcon4",
    "title": "Advanced Sales Forecasting",
    "subTitle": "Forecasts that managers can track against targets each week.",
    "description": "GrowSquare tracks pipeline against targets and builds a forecast from deal stage, deal history and rep commitments, so managers can plan with a number they can explain.",
    "useCaseDescription": "How forecasting supports planning and weekly reviews.",
    "benefits": [
      "Performance tracking vs. targets",
      "Deal probability analysis",
      "Forecast commitment windows"
    ],
    "detailsBenefits": [
      "A forecast that updates as the pipeline changes",
      "Visibility into pipeline health by team, rep and stage",
      "Early warning when a quarter is at risk",
      "Simpler forecast reviews with managers"
    ],
    "useCase": [
      {
        "title": "Performance Tracking vs. Targets",
        "description": "Compares pipeline and closed revenue with team and rep targets",
        "result": "Shows who is on track and who needs support"
      },
      {
        "title": "Deal Probability Analysis",
        "description": "Estimates the likelihood of each deal closing from stage and history",
        "result": "Gives managers a second view next to rep judgement"
      },
      {
        "title": "Forecast Commitment Windows",
        "description": "Lets reps commit deals for a set period and tracks changes",
        "result": "Makes forecast movement visible week to week"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Pipeline Tracking",
        "description": "Monitor deals by stage, owner and expected close date."
      },
      {
        "id": 2,
        "title": "Probability Modeling",
        "description": "Estimate close likelihood and expected revenue for each deal."
      },
      {
        "id": 3,
        "title": "Commitment Forecasting",
        "description": "Record commitments for a period and track changes against them."
      },
      {
        "id": 4,
        "title": "Learning from History",
        "description": "Compare past forecasts with results to improve future ones."
      }
    ],
    "readyToTitle": "Ready to Improve Your Forecast Reviews?",
    "readyToDescription": "See how live pipeline data feeds the forecast."
  },
  {
    "id": 5,
    "icon": "FeatureIcon5",
    "title": "Intelligent Automation for Enhanced Customer Experience",
    "subTitle": "Rules that handle routing, approvals and routine follow-up.",
    "description": "GrowSquare automates routine workflows, assignments and approvals, so leads and cases reach the right person quickly and nothing waits on manual hand-offs.",
    "useCaseDescription": "How automation removes manual steps from everyday work.",
    "benefits": [
      "Business rule automation",
      "Assignment rules management",
      "Approval process automation"
    ],
    "detailsBenefits": [
      "Less repetitive admin for sales and service teams",
      "Faster first response on leads and cases",
      "Work assigned to the right owner using clear rules",
      "Approvals that follow your policy and keep a record"
    ],
    "useCase": [
      {
        "title": "Business Rule Automation",
        "description": "Runs routine actions such as reminders, status changes and notifications",
        "result": "Frees reps to spend more time with customers"
      },
      {
        "title": "Assignment Rules",
        "description": "Routes leads and cases by region, product, workload or priority",
        "result": "Cuts delay between enquiry and first response"
      },
      {
        "title": "Approval Automation",
        "description": "Sends discounts, quotes and exceptions to the right approver",
        "result": "Keeps deals moving and keeps a record of who approved what"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Rule Definition",
        "description": "Set the triggers and conditions for workflows, assignments and approvals."
      },
      {
        "id": 2,
        "title": "Workflow Automation",
        "description": "Run the actions automatically when a trigger fires."
      },
      {
        "id": 3,
        "title": "Assignment",
        "description": "Route leads and cases to the right team member."
      },
      {
        "id": 4,
        "title": "Review",
        "description": "Check which rules are used and adjust them as your process changes."
      }
    ],
    "readyToTitle": "Ready to Cut Manual Work?",
    "readyToDescription": "See how assignment, reminders and approvals are set up in the product."
  },
  {
    "id": 6,
    "icon": "FeatureIcon6",
    "title": "Customer Experience Personalization",
    "subTitle": "One profile per customer, used to tailor outreach.",
    "description": "GrowSquare keeps one profile for each customer, with their history, preferences and recent activity, and uses it to make outreach more relevant.",
    "useCaseDescription": "How a single customer profile supports more relevant contact.",
    "benefits": [
      "Dynamic customer profiles",
      "AI-assisted contextual email drafts",
      "Customer 360 view"
    ],
    "detailsBenefits": [
      "One view of each customer across sales, service and marketing",
      "AI-assisted email drafts that reflect each customer’s history, ready to review in seconds",
      "Stronger retention through timely, relevant contact"
    ],
    "useCase": [
      {
        "title": "Dynamic Profiles",
        "description": "Combines CRM, email and case data into one customer record",
        "result": "Anyone who speaks to the customer sees the same context"
      },
      {
        "title": "AI-Assisted Email Drafts",
        "description": "Generates highly contextual email drafts from the customer’s profile, open cases, recent conversations and interactions",
        "result": "Reps and account managers review and edit a draft in seconds instead of writing from scratch"
      },
      {
        "title": "Customer 360 Insights",
        "description": "Shows recent wins, cases, campaigns and conversations together",
        "result": "Helps teams plan renewals and retention work"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Profile Aggregation",
        "description": "Combine customer data from the CRM and connected tools."
      },
      {
        "id": 2,
        "title": "Personalization",
        "description": "Tailor messages to segment, preferences and history."
      },
      {
        "id": 3,
        "title": "Contextual Email Drafts",
        "description": "AI drafts emails from each customer’s profile and recent activity, and your team reviews and sends them."
      },
      {
        "id": 4,
        "title": "Journey Review",
        "description": "Check results and adjust the messages and timing."
      }
    ],
    "readyToTitle": "Ready to Build a Customer 360?",
    "readyToDescription": "See how profiles and outreach work together."
  },
  {
    "id": 7,
    "icon": "FeatureIcon7",
    "title": "Advanced Business Intelligence",
    "subTitle": "Dashboards and reports across sales, service and marketing.",
    "description": "GrowSquare gives sales, service and marketing teams dashboards and reports built from the same CRM data, so everyone works from the same numbers.",
    "useCaseDescription": "How reporting and dashboards are used across teams.",
    "benefits": [
      "Unified business dashboards",
      "Advanced reporting and analytics",
      "Data-driven growth insights"
    ],
    "detailsBenefits": [
      "One set of figures for sales, service and marketing",
      "Dashboards for each role, from rep to executive",
      "Trends and gaps that are easy to spot",
      "Quicker answers without waiting for a custom report"
    ],
    "useCase": [
      {
        "title": "Unified Dashboards",
        "description": "Brings pipeline, cases and campaign results into shared views",
        "result": "Gives managers and leadership one place to check performance"
      },
      {
        "title": "Advanced Analytics",
        "description": "Breaks results down by segment, source, product and period",
        "result": "Helps teams see what is working and what is not"
      },
      {
        "title": "Growth Insights",
        "description": "Highlights segments and regions with room to grow",
        "result": "Supports planning for territories and campaigns"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Data Consolidation",
        "description": "Bring data from the CRM and connected systems into one place."
      },
      {
        "id": 2,
        "title": "Analytics & Reporting",
        "description": "Build reports and dashboards for each team."
      },
      {
        "id": 3,
        "title": "Insight Sharing",
        "description": "Share reports with the people who need them on a schedule."
      },
      {
        "id": 4,
        "title": "Decisions",
        "description": "Use the numbers in weekly reviews and planning."
      }
    ],
    "readyToTitle": "Ready to Get Clearer Reporting?",
    "readyToDescription": "See the dashboards your teams would use."
  },
  {
    "id": 8,
    "icon": "FeatureIcon8",
    "title": "Intelligent Marketing & Asset Management",
    "subTitle": "Segment audiences, run campaigns, build emails and landing pages faster, and keep brand assets in one library.",
    "description": "GrowSquare helps your marketing team segment audiences, plan and run campaigns, create emails and landing pages faster with AI assistance, test what performs best, and keep logos, images, videos and documents in one managed library.",
    "useCaseDescription": "How marketing teams segment, create, run and manage campaigns in one place.",
    "benefits": [
      "Segmentation and campaign management",
      "AI-assisted email templates and landing pages with A/B testing and analytics",
      "Digital asset management"
    ],
    "detailsBenefits": [
      "Audience segments built from CRM data, so each campaign reaches the right people",
      "Campaigns planned, scheduled and tracked in one place",
      "First drafts of email templates and landing pages in minutes, which your team then edits",
      "A/B tests on subject lines, content and page layouts",
      "Campaign results reported next to your leads and deals",
      "One approved library of brand assets, so teams stop searching shared drives and old emails"
    ],
    "useCase": [
      {
        "title": "Segmentation",
        "description": "Groups leads and contacts by industry, behavior, deal stage or any CRM field, and keeps the segments up to date",
        "result": "Messages go to the people they are relevant to"
      },
      {
        "title": "Campaign Management",
        "description": "Plans, schedules and runs email and landing page campaigns, with owners, dates and audiences in one view",
        "result": "Teams see what is live, what is planned and how each campaign is performing"
      },
      {
        "title": "AI-Assisted Email Templates",
        "description": "Drafts email copy and layouts from a short brief, tone and audience",
        "result": "Marketers review and edit the draft, then save it as a reusable template"
      },
      {
        "title": "AI-Assisted Landing Pages",
        "description": "Creates a landing page draft with a form that sends leads straight into the CRM",
        "result": "Cuts the time from campaign idea to a live page"
      },
      {
        "title": "A/B Testing & Analytics",
        "description": "Runs two versions of an email or landing page against each other",
        "result": "Shows opens, clicks, form submissions and leads created, so the better version is clear"
      },
      {
        "title": "Digital Asset Management",
        "description": "Stores logos, images, videos, brochures and documents in a searchable library",
        "result": "Teams use current, approved files in emails and landing pages, with access set by role"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Segment",
        "description": "Build the audience from CRM fields, deal stage and past activity."
      },
      {
        "id": 2,
        "title": "Create and Launch",
        "description": "Draft the email or landing page with AI, edit it, then schedule the campaign."
      },
      {
        "id": 3,
        "title": "Test and Measure",
        "description": "Compare versions with an A/B test and review results by campaign and lead source."
      },
      {
        "id": 4,
        "title": "Manage Assets",
        "description": "Store the final images, documents and templates in the asset library for the next campaign."
      }
    ],
    "readyToTitle": "Ready to Plan Your Next Campaign in GrowSquare?",
    "readyToDescription": "See how segmentation, campaigns, email, landing pages, testing and the asset library work together."
  },
  {
    "id": 9,
    "icon": "FeatureIcon9",
    "title": "Enhanced Customer Engagement & Financial Transparency",
    "subTitle": "Quotes, invoices and cases handled in the same system as the deal.",
    "description": "GrowSquare handles quotes, invoices and customer cases in the same system as the deal, so customers get clear answers and your team does not re-enter data.",
    "useCaseDescription": "How quotes, invoices and cases are handled alongside the sales record.",
    "benefits": [
      "Quote management and tracking",
      "Transparent invoicing",
      "Customer case management"
    ],
    "detailsBenefits": [
      "Quotes created from the deal and tracked until accepted",
      "Invoices that match the agreed quote",
      "Customer questions handled as cases with a clear owner",
      "Fewer billing queries and faster resolution"
    ],
    "useCase": [
      {
        "title": "Quote Management & Tracking",
        "description": "Creates quotes from deal data and records versions, status and approvals",
        "result": "Speeds up quoting and reduces errors"
      },
      {
        "title": "Transparent Invoicing",
        "description": "Produces invoices from approved quotes and orders",
        "result": "Customers see clear charges, which reduces disputes"
      },
      {
        "title": "Case Management",
        "description": "Logs customer issues, assigns an owner and tracks them to resolution",
        "result": "Customers get faster answers with the full history on hand"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Quote Management",
        "description": "Create quotes from the deal and send them for approval."
      },
      {
        "id": 2,
        "title": "Billing",
        "description": "Generate invoices from approved quotes and orders."
      },
      {
        "id": 3,
        "title": "Support",
        "description": "Log and resolve customer cases with clear ownership."
      },
      {
        "id": 4,
        "title": "Follow-Up",
        "description": "Check in with customers after invoices and cases close."
      }
    ],
    "readyToTitle": "Ready to Simplify Quotes, Invoices and Cases?",
    "readyToDescription": "See how quoting, billing and service sit in one record."
  }
];

export const crmFeaturesCopy = [
  {
    id: 1,
    title: "Customer Intelligence & Engagement",
    subTitle: "Turn prospects into engaged contacts with AI-driven research and nurturing.",
    description: "GrowSquare acts as your research assistant, gathering intelligence on your ideal customers, identifying decision-makers, and nurturing them into engaged contacts to drive meaningful relationships.",
    icon: "FeatureIcon1",
    benefits: [
      "Customer intelligence collection",
      "Target role identification",
      "Automated lead nurturing"
    ]
  },
  {
    id: 2,
    title: "Intelligent Deal Orchestration",
    subTitle: "AI that adapts processes and drives deals to closure.",
    description: "Our AI orchestrates every stage of your deals, creating win strategies and account plans that maximize outcomes and enhance customer engagement throughout the sales journey.",
    icon: "FeatureIcon2",
    benefits: [
      "Deal process orchestration",
      "AI-generated win strategies",
      "Genie Sales Bot for deal and pipeline questions"
    ]
  },
  {
    id: 4,
    title: "Advanced Sales Forecasting",
    subTitle: "Real-time forecasting that keeps revenue plans accurate and customer expectations aligned.",
    description: "Stay ahead with forecasting that tracks targets, analyzes pipeline health, and provides realistic outlooks to ensure customers experience consistent, reliable delivery.",
    icon: "FeatureIcon4",
    benefits: [
      "Performance tracking vs. targets",
      "Deal probability analysis",
      "Forecast commitment windows"
    ]
  },
];
export const solutions = [
  {
    "id": 1,
    "icon": "SolutionIcon1",
    "title": "Sales Pipeline Optimization",
    "subTitle": "Give every lead and deal a clear stage, owner and next step.",
    "description": "GrowSquare gives every lead and deal a stage, an owner and a next step, so managers can see what is moving and what is stuck.",
    "useCaseDescription": "How teams use GrowSquare to organize their pipeline.",
    "features": [
      "Lead-to-contact conversion workflows",
      "Deal pipeline visualization",
      "Automated deal value and forecast calculations",
      "Deal process orchestration with AI-generated win strategies",
      "Genie Sales Bot for questions and priority tasks",
      "Predictive lead and deal scoring"
    ],
    "detailsFeatures": [
      "Faster movement from lead to deal through structured qualification",
      "A pipeline view that makes priorities clear",
      "Suggested win strategies for each opportunity",
      "Lead and deal scores that help reps choose who to call first"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "Lead-to-Contact Conversion",
        "description": "Qualifies leads with a standard set of questions and converts them to contacts and deals",
        "result": "Reps spend time on leads that fit"
      },
      {
        "id": 2,
        "title": "Deal Pipeline Visualization",
        "description": "Shows deals by stage, value and age",
        "result": "Managers can see where deals are stuck and step in"
      },
      {
        "id": 3,
        "title": "Predictive Lead & Deal Scoring",
        "description": "Scores leads and deals based on past wins",
        "result": "Gives reps a sensible order for their day"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Capture & Qualify",
        "description": "Capture leads from forms, email and campaigns and qualify them with a standard process."
      },
      {
        "id": 2,
        "title": "Plan the Deal",
        "description": "Create a suggested win strategy and tasks for each opportunity."
      },
      {
        "id": 3,
        "title": "Track Progress",
        "description": "Follow deals through the pipeline with dashboards by stage and owner."
      },
      {
        "id": 4,
        "title": "Score & Prioritize",
        "description": "Use scores to decide which leads and deals to work on first."
      }
    ],
    "readyToTitle": "Ready to Organize Your Pipeline?",
    "readyToDescription": "See how stages, tasks and scores work on a real pipeline."
  },
  {
    "id": 2,
    "icon": "SolutionIcon2",
    "title": "Accurate Forecasting & Goal Alignment",
    "subTitle": "Replace spreadsheet forecasts with numbers built from live pipeline data.",
    "description": "GrowSquare gives managers a forecast built from live pipeline data and shows team and individual progress against goals.",
    "useCaseDescription": "How forecasting and goal tracking work together.",
    "features": [
      "Revenue forecasting by deal and account",
      "Forecast deviation analysis",
      "Team and individual goal tracking",
      "Performance tracking vs. targets",
      "Forecast commitment windows"
    ],
    "detailsFeatures": [
      "A forecast built from the pipeline, not from separate spreadsheets",
      "Goals for teams and individuals in one place",
      "Tracking of changes against the last committed baseline",
      "Clear visibility into who is on track"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "Revenue Forecasting",
        "description": "Builds projections from open deals, stages and probabilities",
        "result": "Gives leadership a number they can plan around"
      },
      {
        "id": 2,
        "title": "Goal Tracking Dashboards",
        "description": "Shows progress against targets for each team and rep",
        "result": "Makes weekly reviews quicker and more factual"
      },
      {
        "id": 3,
        "title": "Forecast Commitment Windows",
        "description": "Records what was committed for a period and what changed",
        "result": "Shows where expectations moved and why"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Data Aggregation",
        "description": "Collect pipeline and revenue data across deals and accounts."
      },
      {
        "id": 2,
        "title": "Probability Analysis",
        "description": "Estimate close probability and highlight risk and deviation."
      },
      {
        "id": 3,
        "title": "Performance Tracking",
        "description": "Track team and rep progress against targets."
      },
      {
        "id": 4,
        "title": "Commitments",
        "description": "Record commitments for each period and review changes."
      }
    ],
    "readyToTitle": "Ready for a Forecast You Can Explain?",
    "readyToDescription": "See how pipeline data becomes a forecast."
  },
  {
    "id": 3,
    "icon": "SolutionIcon3",
    "title": "Customer Incident Management",
    "subTitle": "Log, assign and resolve customer issues with the full history in view.",
    "description": "GrowSquare logs every customer issue from first contact to resolution, assigns an owner and keeps the full history in one place.",
    "useCaseDescription": "How teams handle cases with GrowSquare.",
    "features": [
      "Centralized case tracking",
      "Automated ownership assignment",
      "Linked communication history",
      "Approval process automation for service escalations",
      "AI-driven prioritization of high-impact cases"
    ],
    "detailsFeatures": [
      "Cases routed to the right owner by rule",
      "Full history visible to everyone who handles the case",
      "High-impact issues surfaced first",
      "Escalations that follow your approval process"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "Centralized Case Tracking",
        "description": "Records cases from email, phone and web in one list",
        "result": "Nothing gets lost and everyone sees the status"
      },
      {
        "id": 2,
        "title": "Automated Assignment",
        "description": "Assigns cases by rule, such as product, region or priority",
        "result": "Cuts waiting time before someone picks the case up"
      },
      {
        "id": 3,
        "title": "AI-Assisted Prioritization",
        "description": "Flags cases that look urgent or affect important accounts",
        "result": "Helps teams decide what to handle first"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Case Capture",
        "description": "Log cases from email, phone and web forms."
      },
      {
        "id": 2,
        "title": "Assignment",
        "description": "Route each case to an owner using your rules."
      },
      {
        "id": 3,
        "title": "Context",
        "description": "Link earlier conversations and account details to the case."
      },
      {
        "id": 4,
        "title": "Prioritize & Escalate",
        "description": "Flag urgent cases and escalate them for approval or support."
      }
    ],
    "readyToTitle": "Ready to Tighten Up Customer Support?",
    "readyToDescription": "See how a case moves from first contact to resolution."
  },
  {
    "id": 4,
    "icon": "SolutionIcon4",
    "title": "Targeted Marketing Campaigns",
    "subTitle": "Plan, send and measure campaigns from the CRM.",
    "description": "GrowSquare lets marketing teams segment audiences, build emails and landing pages with AI assistance, test versions and see which campaigns produce leads.",
    "useCaseDescription": "How marketing teams plan, run and measure campaigns.",
    "features": [
      "Lead and contact segmentation",
      "AI-assisted email templates and landing pages",
      "A/B testing and campaign analytics",
      "Email campaign execution",
      "Digital asset library for campaign materials"
    ],
    "detailsFeatures": [
      "Audience segments built from CRM data",
      "Faster creation of emails and landing pages",
      "A/B testing to compare versions",
      "Campaign results tied to leads and revenue"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "Audience Segmentation",
        "description": "Groups leads and contacts by industry, behavior, stage or any CRM field",
        "result": "Messages are sent to people they are relevant to"
      },
      {
        "id": 2,
        "title": "Email & Landing Page Creation",
        "description": "Drafts emails and landing pages with AI help and stores them as templates",
        "result": "Shortens campaign preparation time"
      },
      {
        "id": 3,
        "title": "Campaign Analytics",
        "description": "Reports opens, clicks, form fills and leads created for each version",
        "result": "Shows which campaigns and messages are worth repeating"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Segment",
        "description": "Build the audience from CRM fields and past activity."
      },
      {
        "id": 2,
        "title": "Create",
        "description": "Draft the email and landing page, then edit and approve them."
      },
      {
        "id": 3,
        "title": "Send & Test",
        "description": "Launch the campaign and compare versions with an A/B test."
      },
      {
        "id": 4,
        "title": "Review",
        "description": "Check results by campaign and lead source, and reuse what worked."
      }
    ],
    "readyToTitle": "Ready to Run Campaigns from Your CRM?",
    "readyToDescription": "See how campaigns connect to leads and deals."
  },
  {
    "id": 5,
    "icon": "SolutionIcon5",
    "title": "Financial Process Streamlining",
    "subTitle": "Connect quoting, ordering and invoicing to the deal.",
    "description": "GrowSquare connects quoting, ordering and invoicing to the deal, and keeps sales and finance working from the same records.",
    "useCaseDescription": "How sales and finance work from the same information.",
    "features": [
      "Quote-to-order-to-invoice automation",
      "Billing lifecycle tracking",
      "Sync between sales and finance records",
      "Quote management and tracking"
    ],
    "detailsFeatures": [
      "Quotes, orders and invoices created from deal data",
      "Billing status visible to sales and finance",
      "Fewer manual entries and fewer errors",
      "Approvals recorded against each quote"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "Quote Automation",
        "description": "Builds quotes from products and price lists and routes them for approval",
        "result": "Shortens the time to get a quote to the customer"
      },
      {
        "id": 2,
        "title": "Transparent Billing",
        "description": "Creates invoices that match the agreed quote or order",
        "result": "Reduces billing questions and disputes"
      },
      {
        "id": 3,
        "title": "Sales-Finance Sync",
        "description": "Keeps customer, order and invoice data aligned between systems",
        "result": "Cuts duplicate entry and reconciliation work"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Quote to Invoice",
        "description": "Create quotes, orders and invoices from the deal."
      },
      {
        "id": 2,
        "title": "Sync",
        "description": "Share sales and finance data between the CRM and your accounting system."
      },
      {
        "id": 3,
        "title": "Lifecycle Tracking",
        "description": "Follow each quote through order, invoice and payment."
      },
      {
        "id": 4,
        "title": "Approvals",
        "description": "Route exceptions to approvers and keep a record."
      }
    ],
    "readyToTitle": "Ready to Connect Sales and Finance?",
    "readyToDescription": "See how a deal turns into an invoice."
  },
  {
    "id": 6,
    "icon": "SolutionIcon6",
    "title": "Data Integrity & Collaboration",
    "subTitle": "Keep one clean record per customer and share it with the right people.",
    "description": "GrowSquare prevents duplicate records, controls who can see what, and gives teams shared tasks and notes on the same customer record.",
    "useCaseDescription": "How teams keep customer data clean and shared.",
    "features": [
      "Duplicate record management",
      "Role-based sharing permissions",
      "Shared tasks and notes",
      "Unified email connectivity"
    ],
    "detailsFeatures": [
      "Fewer duplicate records and more reliable reports",
      "Access set by role",
      "Shared tasks and notes on each account",
      "Email linked to the right record"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "Duplicate Management",
        "description": "Detects likely duplicates and helps merge them",
        "result": "Reports and forecasts rest on cleaner data"
      },
      {
        "id": 2,
        "title": "Secure Sharing",
        "description": "Sets record access by role, team or ownership",
        "result": "Sensitive data stays with the people who need it"
      },
      {
        "id": 3,
        "title": "Team Collaboration",
        "description": "Provides shared tasks, notes and activity on each record",
        "result": "Sales, service and marketing see the same context"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Duplicate Management",
        "description": "Find and merge duplicate records."
      },
      {
        "id": 2,
        "title": "Access Control",
        "description": "Set sharing rules by role and team."
      },
      {
        "id": 3,
        "title": "Collaboration",
        "description": "Share tasks, notes and updates on the record."
      },
      {
        "id": 4,
        "title": "Linked History",
        "description": "Keep emails and conversations attached to the customer."
      }
    ],
    "readyToTitle": "Ready for Cleaner Data?",
    "readyToDescription": "See how duplicate checks, permissions and shared tasks work."
  },
  {
    "id": 7,
    "icon": "SolutionIcon7",
    "title": "System Integration & CRM Migration",
    "subTitle": "Move off a legacy CRM and connect the systems around it.",
    "description": "GrowSquare helps you move from a legacy CRM and connects the systems around it, so customer data stays consistent.",
    "useCaseDescription": "How migration and integration projects are handled.",
    "features": [
      "Secure API integrations",
      "Legacy CRM migration support",
      "Data synchronization between systems",
      "Consistent customer data across channels"
    ],
    "detailsFeatures": [
      "Planned migration with data mapping and checks",
      "One customer view across connected tools",
      "Secure API connections to in-house and third-party systems",
      "A CRM setup that can grow with you"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "Legacy CRM Migration",
        "description": "Maps, cleans and loads data from your existing CRM",
        "result": "Keeps history and reduces disruption to the team"
      },
      {
        "id": 2,
        "title": "Secure API Integration",
        "description": "Connects GrowSquare to in-house and third-party applications",
        "result": "Reduces manual transfers between systems"
      },
      {
        "id": 3,
        "title": "Data Synchronization",
        "description": "Keeps shared records aligned across systems",
        "result": "Gives teams one version of the customer"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Data Assessment",
        "description": "Review and prepare the data in your current CRM."
      },
      {
        "id": 2,
        "title": "Migration",
        "description": "Map fields, load a test set, check the results, then migrate."
      },
      {
        "id": 3,
        "title": "Integration",
        "description": "Connect other systems through secure APIs."
      },
      {
        "id": 4,
        "title": "Cut-Over",
        "description": "Switch teams over and monitor data quality afterwards."
      }
    ],
    "readyToTitle": "Ready to Move or Connect Your CRM?",
    "readyToDescription": "Talk to us about your current system and what needs to connect."
  },
  {
    "id": 8,
    "icon": "SolutionIcon8",
    "title": "Tailored CRM Customization",
    "subTitle": "Adjust modules, fields and workflows to match how your business runs.",
    "description": "GrowSquare can be adjusted to your business, with custom modules, fields, workflows and industry-specific extensions.",
    "useCaseDescription": "What can be customized.",
    "features": [
      "Custom module development",
      "Workflow and rule customization",
      "Industry-focused extensions",
      "Business rule automation",
      "Dynamic customer profiles"
    ],
    "detailsFeatures": [
      "Workflows that follow how your business sells and serves",
      "Modules and fields for the data you actually track",
      "Extensions for industry needs",
      "Rules that can be updated as your process changes"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "Custom Modules",
        "description": "Adds modules for things such as properties, policies, programmes or installed equipment",
        "result": "The CRM reflects your business, not a generic template"
      },
      {
        "id": 2,
        "title": "Rule Automation",
        "description": "Builds workflows and approvals for your internal policies",
        "result": "Removes repetitive steps and enforces your process"
      },
      {
        "id": 3,
        "title": "Dynamic Profiles",
        "description": "Adds the fields and views each team needs on customer records",
        "result": "Teams see the information relevant to their role"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Module Configuration",
        "description": "Set up modules and fields around your workflows."
      },
      {
        "id": 2,
        "title": "Rules & Automation",
        "description": "Define rules, approvals and automation paths."
      },
      {
        "id": 3,
        "title": "Extensions",
        "description": "Add industry-focused extensions where needed."
      },
      {
        "id": 4,
        "title": "Ongoing Changes",
        "description": "Adjust the setup as your business changes."
      }
    ],
    "readyToTitle": "Ready to Fit the CRM to Your Business?",
    "readyToDescription": "Tell us about your process and we will show how it would be set up."
  },
  {
    "id": 9,
    "icon": "SolutionIcon9",
    "title": "Strategic CRM Services",
    "subTitle": "Help with rollout, adoption and ongoing improvement.",
    "description": "GrowSquare provides help with rollout, adoption and ongoing improvement, so the CRM keeps delivering value after go-live.",
    "useCaseDescription": "The services available alongside the software.",
    "features": [
      "CRM implementation services",
      "Continuous optimization support",
      "Strategic advisory sessions",
      "Churn detection and proactive engagement",
      "Customer 360 views"
    ],
    "detailsFeatures": [
      "Planned onboarding that gets teams using the system",
      "Regular reviews of usage and reports",
      "Advice on aligning the CRM with business goals",
      "Churn alerts and prompts to act on at-risk accounts"
    ],
    "useCase": [
      {
        "id": 1,
        "title": "CRM Onboarding",
        "description": "Plans the rollout, trains users and supports the first weeks",
        "result": "Teams become comfortable with the system sooner"
      },
      {
        "id": 2,
        "title": "Strategic Advisory",
        "description": "Reviews your process and recommends changes to the CRM setup",
        "result": "Keeps the system aligned as the business grows"
      },
      {
        "id": 3,
        "title": "Insights Review",
        "description": "Reviews churn alerts, scores and reports with your team",
        "result": "Helps you act on what the data shows"
      }
    ],
    "howItworks": [
      {
        "id": 1,
        "title": "Onboarding & Deployment",
        "description": "Plan the rollout and support users through go-live."
      },
      {
        "id": 2,
        "title": "Usage Monitoring",
        "description": "Track who is using what and where adoption is low."
      },
      {
        "id": 3,
        "title": "Advisory",
        "description": "Review goals and adjust the setup to meet them."
      },
      {
        "id": 4,
        "title": "Insights Review",
        "description": "Go through churn alerts and reports and agree actions."
      }
    ],
    "readyToTitle": "Ready for Help Beyond Go-Live?",
    "readyToDescription": "Talk to us about the support that suits your team."
  }
];

export const industries = [
  {
    "id": 1,
    "icon": "IndustryIcon1",
    "name": "Information Technology & Software",
    "description": "Long evaluations with several stakeholders, then renewals and expansion.",
    "setupHighlights": [
      "Stages from qualification through technical evaluation to renewal",
      "Subscription, seat and renewal-date tracking",
      "Churn alerts on key accounts"
    ],
    "intro": "Software and IT services deals involve several stakeholders and a technical evaluation, and the relationship continues through renewals and expansion. GrowSquare is configured around that cycle.",
    "knowledge": "Buyers usually include a technical evaluator, a business sponsor and someone from security or procurement. Revenue comes from subscriptions, support contracts and add-ons, so renewal dates and expansion matter as much as new sales.",
    "needs": [
      "Tracking several stakeholders on one deal",
      "Managing trials and proofs of concept",
      "Seeing renewals coming 90 days or more ahead",
      "Spotting accounts at risk before renewal"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Qualify",
          "Discovery",
          "Technical evaluation or proof of concept",
          "Proposal",
          "Security and procurement review",
          "Negotiation",
          "Closed won, then renewal"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "Product or plan, seats or licences, contract term, renewal date",
          "Annual or monthly recurring revenue per account",
          "Stakeholder roles on each deal",
          "Integration needs and support tier"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Renewal reminders at 90, 60 and 30 days",
          "Discount approval above a set threshold",
          "Lead assignment by region or product",
          "Hand-off task to customer success when a deal closes"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Pipeline by stage and product",
          "Renewal pipeline and expected renewal revenue",
          "Accounts flagged for churn risk",
          "Quota attainment by rep and team"
        ]
      }
    ],
    "scenario": {
      "situation": "A software company sells annual subscriptions to mid-sized businesses. Renewals were tracked in spreadsheets and managed by whoever remembered.",
      "setup": "We add a renewal date and contract value to every account, create a renewal pipeline with reminders, and add a churn-risk flag based on support cases and usage notes.",
      "outcome": "Account managers start renewal conversations earlier, and leadership sees expected renewal revenue by month."
    },
    "detailsFeatures": [
      {
        "title": "Intelligent Deal Orchestration",
        "description": "Manages multi-stakeholder deals and evaluation stages"
      },
      {
        "title": "ML-Powered Insights & Predictions",
        "description": "Flags accounts at risk before renewal"
      },
      {
        "title": "Advanced Sales Forecasting",
        "description": "Separates new business and renewal forecasts"
      },
      {
        "title": "Intelligent Marketing & Asset Management",
        "description": "Landing pages for webinars and launches, with A/B tests"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review your sales stages, renewal process and handover to customer success."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up stages, fields, renewal tracking and integrations with your billing and support tools."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train sales, solution engineers and customer success on their own views."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review renewal and pipeline reports and adjust the setup."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Software and IT?",
    "readyToDescription": "Book a demo and we will set up a software sales pipeline with renewals before the call."
  },
  {
    "id": 2,
    "icon": "IndustryIcon2",
    "name": "Financial Services & Banking",
    "description": "Advisor-led relationships with onboarding checks and regular reviews.",
    "setupHighlights": [
      "Client and household records with products held",
      "Onboarding status and consent tracking",
      "Review reminders and referral tracking between teams"
    ],
    "intro": "Banks, lenders, insurers and wealth firms run on long-term relationships, regular reviews and controlled processes. GrowSquare is configured around the client, the products they hold and the checks that come with them.",
    "knowledge": "Relationships are usually managed by an advisor or relationship manager, often for a household or business with several products. Onboarding involves identity and suitability checks, and clients expect to be contacted on a regular schedule and only for purposes they have agreed to.",
    "needs": [
      "A single view of each client and the products they hold",
      "Tracking onboarding steps and consent preferences",
      "Scheduled reviews and referral hand-offs between teams",
      "Access limited to the advisor and the team that needs it"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Lead",
          "Initial meeting",
          "Needs analysis",
          "Proposal",
          "Onboarding and documentation",
          "Account opened or funded",
          "Periodic review"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "Client type: individual, household or business",
          "Products held and product interest",
          "Onboarding status and consent preferences",
          "Assigned advisor, branch and review date"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Review reminders based on client segment",
          "Approval routing for pricing or policy exceptions",
          "Referral tasks between retail, lending and wealth teams",
          "Alert when a client has not been contacted for a set period"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Pipeline by advisor and product",
          "Products per client and cross-sell opportunities",
          "Overdue reviews and onboarding items",
          "Referrals sent and converted"
        ]
      }
    ],
    "scenario": {
      "situation": "A regional lender and wealth firm has advisors using personal spreadsheets. Reviews are missed and referrals between teams go unrecorded.",
      "setup": "We create client and household records with products held, add review dates and reminders, and build a referral workflow between teams with role-based access.",
      "outcome": "Managers see which reviews are overdue and which referrals are open, and advisors see only their own clients."
    },
    "detailsFeatures": [
      {
        "title": "Customer Intelligence & Engagement",
        "description": "Keeps client and household profiles current"
      },
      {
        "title": "Customer Experience Personalization",
        "description": "Provides a Customer 360 view for advisors"
      },
      {
        "title": "Enhanced Customer Engagement & Financial Transparency",
        "description": "Handles quotes, invoices and service cases"
      },
      {
        "title": "Intelligent Automation for Enhanced Customer Experience",
        "description": "Runs reminders, approvals and routing"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review client segments, onboarding steps, review cycles and access rules."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up client records, stages, approvals and role-based access."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train advisors, onboarding teams and managers on their own views."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review overdue items and referral reports and tune the setup."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Financial Services?",
    "readyToDescription": "Book a demo and we will set up a client and review workflow before the call."
  },
  {
    "id": 3,
    "icon": "IndustryIcon3",
    "name": "Healthcare & Pharmaceuticals",
    "description": "Territory-based engagement with clinicians, hospitals and distributors.",
    "setupHighlights": [
      "Institution and clinician records by territory",
      "Visit logging and follow-up tasks",
      "Contract, tender and service-case tracking"
    ],
    "intro": "Healthcare suppliers, pharmaceutical companies and service providers work with institutions, clinicians and distributors across territories. GrowSquare is configured around those relationships and the follow-up they need.",
    "knowledge": "Sales teams cover territories and call on hospitals, clinics and clinicians. Contracts often go through tenders or formal evaluation, and service and complaint handling matter after the sale. Some customer information is sensitive, so what goes into the CRM needs to be decided deliberately.",
    "needs": [
      "Institution and clinician records organized by territory",
      "Planning and logging visits, with follow-up tasks",
      "Tracking tenders, contracts and renewal dates",
      "Handling service requests and complaints with escalation"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Identify",
          "Introduce",
          "Evaluate or trial",
          "Tender or contract",
          "Onboard",
          "Supply and support"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "Institution type, speciality and territory",
          "Clinician and administrator contacts with preferred channel",
          "Product interest and contract or tender dates",
          "Consent and communication preferences"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Follow-up task after each visit",
          "Case routing and escalation for service issues and complaints",
          "Contract expiry reminders",
          "Approval routing for pricing and special terms"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Visits against plan by territory",
          "Accounts by speciality and potential",
          "Open cases by age and priority",
          "Contracts and tenders due for renewal"
        ]
      }
    ],
    "scenario": {
      "situation": "A medical device supplier has reps visiting hospitals in several regions. Visit notes sit in personal notebooks and service complaints reach the sales team by phone.",
      "setup": "We organize accounts by territory, add a simple visit log with automatic follow-up tasks, and route complaints into a case queue. Patient-level data stays in the hospital systems and out of the CRM.",
      "outcome": "Managers see coverage by territory and open cases by age, and reps start each visit with the account history."
    },
    "detailsFeatures": [
      {
        "title": "Customer Intelligence & Engagement",
        "description": "Maps institutions and key contacts"
      },
      {
        "title": "Intelligent Automation for Enhanced Customer Experience",
        "description": "Handles follow-up tasks and case routing"
      },
      {
        "title": "Enhanced Customer Engagement & Financial Transparency",
        "description": "Manages quotes, contracts and service cases"
      },
      {
        "title": "Intelligent Marketing & Asset Management",
        "description": "Keeps approved brochures and product material in one library"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review territories, contact types, contract process and what data belongs in the CRM."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up account structure, visit logging, case handling and access rules."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train field reps, customer service and managers."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review coverage and case reports and adjust."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Healthcare and Pharma?",
    "readyToDescription": "Book a demo and we will set up territory and visit tracking before the call."
  },
  {
    "id": 4,
    "icon": "IndustryIcon4",
    "name": "Real Estate & Property Management",
    "description": "High enquiry volume, viewings, offers, leases and maintenance.",
    "setupHighlights": [
      "Property and listing records linked to leads and owners",
      "Viewing reminders and follow-up",
      "Lease renewal and maintenance request tracking"
    ],
    "intro": "Agencies, developers and property managers handle a high volume of enquiries, properties and tenants. GrowSquare is configured so every lead, property and lease can be tracked in one place.",
    "knowledge": "Leads arrive from portals, campaigns and walk-ins and need a fast response. A single lead may view several properties, and an owner may have several listings. On the management side, leases, renewals and maintenance requests drive most of the workload.",
    "needs": [
      "Fast assignment and follow-up of new enquiries",
      "Property records linked to leads, owners and tenants",
      "Scheduling viewings and following up afterwards",
      "Tracking lease renewals and maintenance requests"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Sales: enquiry, qualification, viewing, offer, contract, settlement",
          "Rentals: enquiry, viewing, application, lease signed, renewal"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "A property module with type, location, price or rent, size and status",
          "Links between properties, owners, buyers and tenants",
          "Lead source, budget and preferred areas",
          "Lease start, end and rent review dates"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Lead assignment by area or agent",
          "Viewing reminders and follow-up task after each viewing",
          "Lease expiry reminders",
          "Maintenance requests logged as cases and routed to the right contractor or team"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Leads and conversion by source",
          "Agent pipeline and listings by status",
          "Days on market",
          "Leases due for renewal"
        ]
      }
    ],
    "scenario": {
      "situation": "A residential agency receives enquiries from portals and social campaigns. Leads are shared by email and some wait a day for a reply.",
      "setup": "We set up a property module, assign new enquiries to agents by area, send viewing reminders, and add a follow-up task after each viewing.",
      "outcome": "Response times are visible to managers, and the agency can compare lead sources by viewings and offers."
    },
    "detailsFeatures": [
      {
        "title": "Intelligent Marketing & Asset Management",
        "description": "Landing pages for listings and a library for property photos and brochures"
      },
      {
        "title": "Customer Intelligence & Engagement",
        "description": "Tracks buyer and tenant preferences and follows up"
      },
      {
        "title": "Intelligent Automation for Enhanced Customer Experience",
        "description": "Handles assignment, reminders and maintenance routing"
      },
      {
        "title": "Advanced Business Intelligence",
        "description": "Reports by source, agent and property"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review lead sources, sales and rental processes and how properties are recorded."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up the property module, stages, assignment rules and reminders."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train agents, property managers and administrators."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review conversion and renewal reports and refine the setup."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Real Estate?",
    "readyToDescription": "Book a demo and we will set up a property and lead workflow before the call."
  },
  {
    "id": 5,
    "icon": "IndustryIcon5",
    "name": "Manufacturing & Industrial Goods",
    "description": "Quotations, dealer networks, repeat orders and after-sales service.",
    "setupHighlights": [
      "RFQ-to-order pipeline with margin-based approvals",
      "Dealer and distributor accounts",
      "Warranty and service tracking"
    ],
    "intro": "Manufacturers and industrial suppliers sell through quotations, distributors and repeat orders, and support equipment after delivery. GrowSquare is configured around that cycle.",
    "knowledge": "Sales often start with a request for quotation that needs technical review and pricing approval. Orders may come through dealers, and the same customers reorder regularly. After delivery, warranty, spare parts and service requests keep the relationship active.",
    "needs": [
      "Managing RFQs from enquiry to quote to order",
      "Approving discounts and margins consistently",
      "Working with dealers and distributors",
      "Tracking installed equipment, warranty and service"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Enquiry or RFQ",
          "Technical review",
          "Quotation",
          "Negotiation",
          "Order",
          "Delivery and installation",
          "After-sales"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "Product line, specification, quantity and requested delivery date",
          "Dealer or distributor on each account",
          "Installed equipment and warranty end date",
          "Repeat order history"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Quote approval based on discount or margin",
          "RFQ routing by product line or region",
          "Warranty and service reminders",
          "Service requests logged as cases with escalation"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Quote-to-order conversion",
          "Pipeline by product line",
          "Forecast combining open quotes and expected repeat orders",
          "Open service cases and dealer performance"
        ]
      }
    ],
    "scenario": {
      "situation": "An industrial equipment maker receives RFQs by email and prices them in spreadsheets. Approvals are by phone, and nobody tracks warranty dates.",
      "setup": "We log each RFQ as a deal, build quotes from the price list, route discounts above a limit for approval, and store installed equipment and warranty dates on the account.",
      "outcome": "Sales can see quotes waiting for approval, and service gets reminders before warranty periods end."
    },
    "detailsFeatures": [
      {
        "title": "Intelligent Deal Orchestration",
        "description": "Manages long, technical sales cycles"
      },
      {
        "title": "Advanced Sales Forecasting",
        "description": "Combines open quotes with expected repeat orders"
      },
      {
        "title": "Enhanced Customer Engagement & Financial Transparency",
        "description": "Handles quotes, invoices and service cases"
      },
      {
        "title": "Intelligent Automation for Enhanced Customer Experience",
        "description": "Runs approvals and RFQ routing"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review your RFQ-to-order process, price rules, dealer model and service process."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up quoting, approvals, dealer accounts and installed equipment records."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train sales, sales support, dealers and service teams."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review quote and service reports and adjust the rules."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Manufacturing?",
    "readyToDescription": "Book a demo and we will set up an RFQ and quotation workflow before the call."
  },
  {
    "id": 6,
    "icon": "IndustryIcon6",
    "name": "Retail & E-commerce",
    "description": "Repeat purchases, segments, campaigns and returns.",
    "setupHighlights": [
      "Customer profiles with purchase history",
      "Segmented campaigns and win-back automation",
      "Complaint and returns case handling"
    ],
    "intro": "Retailers and online sellers rely on repeat purchases, targeted campaigns and good handling of returns and complaints. GrowSquare is configured around the customer and their purchase history.",
    "knowledge": "Most of the value comes from bringing customers back. That needs purchase history, segments and timely campaigns, plus a clear process for returns and complaints. Retailers that also sell wholesale need account and pricing management for business buyers.",
    "needs": [
      "Customer profiles with purchase history and preferences",
      "Segmented campaigns and win-back messages",
      "A clear process for returns and complaints",
      "Account management for wholesale and business buyers"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Wholesale accounts: enquiry, account application, pricing agreed, first order, repeat order",
          "Retail customers: new, active, lapsing, lapsed, won back"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "Last order date, order count and average order value",
          "Segment, channel preference and loyalty tier",
          "Consent and communication preferences",
          "Wholesale price list and credit terms"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Win-back campaign for customers inactive for a set period",
          "Follow-up message after purchase",
          "Returns and complaints logged as cases with escalation",
          "Approval for wholesale pricing and credit"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Repeat purchase rate by segment",
          "Campaign results by version and segment",
          "Customers lapsing in the next period",
          "Open cases by type and age"
        ]
      }
    ],
    "scenario": {
      "situation": "An online homeware retailer sends the same promotion to its whole list. Returns are handled in a shared inbox.",
      "setup": "We segment customers by purchase history, build a win-back email and landing page with an A/B test, and log returns as cases with an owner and due date.",
      "outcome": "The team can compare campaign versions by repeat purchases and see how long returns take to resolve."
    },
    "detailsFeatures": [
      {
        "title": "Customer Experience Personalization",
        "description": "Builds customer profiles and tailors outreach"
      },
      {
        "title": "Intelligent Marketing & Asset Management",
        "description": "Email templates, landing pages, A/B tests and a product image library"
      },
      {
        "title": "ML-Powered Insights & Predictions",
        "description": "Flags customers who are likely to lapse"
      },
      {
        "title": "Advanced Business Intelligence",
        "description": "Reports on repeat purchases and campaigns"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review customer segments, campaigns, returns process and any wholesale accounts."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up customer fields, segments, campaign templates and case handling, and connect your e-commerce and payment systems."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train marketing, customer service and account managers."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review campaign and retention reports and refine the segments."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Retail and E-commerce?",
    "readyToDescription": "Book a demo and we will set up customer segments and a win-back campaign before the call."
  },
  {
    "id": 7,
    "icon": "IndustryIcon7",
    "name": "Telecommunications & Utilities",
    "description": "Large customer bases, multi-service accounts, contracts and fault handling.",
    "setupHighlights": [
      "Accounts with services, sites and contract end dates",
      "SLA-based case routing and escalation",
      "Renewal and churn-risk views"
    ],
    "intro": "Telecom and utility providers manage large customer bases, multi-service accounts and a steady flow of service requests. GrowSquare is configured around accounts, contracts and service levels.",
    "knowledge": "Enterprise and business customers have several services and sites under one account, with contract end dates and service levels. Residential volumes are high, so faults, billing queries and renewals need clear routing. Retention often depends on how quickly issues are handled.",
    "needs": [
      "Accounts showing services, sites and contract end dates",
      "Routing faults and requests by priority and service level",
      "Escalating cases that miss their target time",
      "Seeing renewals and at-risk accounts early"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Opportunity",
          "Requirements and site survey",
          "Proposal",
          "Contract",
          "Provisioning",
          "Account management and renewal"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "Services and subscriptions per account",
          "Sites or service locations",
          "Contract end date and service level",
          "Assigned account manager"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Case routing by priority and service level",
          "Escalation when a case passes its target time",
          "Contract renewal alerts",
          "Approval for custom pricing and contract terms"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Renewals due by month",
          "Accounts at risk of churn",
          "Open cases against service-level targets",
          "Provisioning status by order"
        ]
      }
    ],
    "scenario": {
      "situation": "A regional broadband provider sells to businesses. Account managers do not see open faults when they speak to customers, and renewals are noticed late.",
      "setup": "We link cases to accounts and sites, add service-level targets with escalation, and create a renewal view with alerts.",
      "outcome": "Account managers see open faults before calls, and renewals start earlier."
    },
    "detailsFeatures": [
      {
        "title": "ML-Powered Insights & Predictions",
        "description": "Flags accounts at risk of leaving"
      },
      {
        "title": "Intelligent Automation for Enhanced Customer Experience",
        "description": "Routes and escalates cases by service level"
      },
      {
        "title": "Enhanced Customer Engagement & Financial Transparency",
        "description": "Handles cases, quotes and invoices"
      },
      {
        "title": "Advanced Business Intelligence",
        "description": "Reports on renewals, cases and provisioning"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review account structure, service levels, case types and the renewal process."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up accounts with services and sites, case routing and escalation, and connect billing and ticketing systems."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train account managers, service desks and provisioning teams."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review service-level and renewal reports and adjust."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Telecom and Utilities?",
    "readyToDescription": "Book a demo and we will set up accounts, services and case routing before the call."
  },
  {
    "id": 8,
    "icon": "IndustryIcon8",
    "name": "Professional Services & Consulting",
    "description": "Referral-driven sales, proposals, engagements and retainers.",
    "setupHighlights": [
      "Pipeline by service line and referral source",
      "Proposal approvals and rate-by-role pricing",
      "Retainer renewal tracking"
    ],
    "intro": "Consultancies, agencies and advisory firms win work through relationships and referrals, and grow through repeat engagements. GrowSquare is configured around proposals, engagements and client relationships.",
    "knowledge": "Many opportunities come from referrals and existing clients, so source tracking matters. Work is scoped and priced as a proposal, often by role and rate, and is approved by a partner. Retainers and repeat projects are the main source of stable revenue.",
    "needs": [
      "Tracking referral sources and relationship owners",
      "Building proposals with rates by role and country",
      "Partner approval on larger proposals",
      "Following up on proposals and retainer renewals"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Referral or lead",
          "Intro meeting",
          "Scoping",
          "Proposal",
          "Negotiation and statement of work",
          "Engagement started",
          "Review or renewal"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "Service line and engagement type: fixed fee, time and materials or retainer",
          "Relationship owner and referral source",
          "Rates by role and country",
          "Expected start date and renewal date"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Partner approval above a proposal value",
          "Follow-up task a set number of days after a proposal is sent",
          "Retainer renewal reminders",
          "Assignment by service line"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Pipeline by service line",
          "Win rate by referral source",
          "Proposals by age",
          "Revenue by client and engagement type"
        ]
      }
    ],
    "scenario": {
      "situation": "A consulting firm tracks opportunities in a shared spreadsheet, and proposals sit unanswered because nobody owns the follow-up.",
      "setup": "We add referral source and service line to each opportunity, build proposals from role-based rates with partner approval, and create follow-up tasks after each proposal.",
      "outcome": "Partners can see which proposals are waiting and which referral sources win work."
    },
    "detailsFeatures": [
      {
        "title": "Intelligent Deal Orchestration",
        "description": "Manages scoping, proposals and follow-up"
      },
      {
        "title": "Customer Intelligence & Engagement",
        "description": "Tracks relationships and referral networks"
      },
      {
        "title": "Enhanced Customer Engagement & Financial Transparency",
        "description": "Builds quotes and invoices from rates by role"
      },
      {
        "title": "Intelligent Marketing & Asset Management",
        "description": "Landing pages for events and a library for case studies and proposal material"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review service lines, proposal process, rate cards and approval rules."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up stages, rate-based quoting, approvals and referral tracking."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train partners, consultants and business development staff."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review win rate and proposal reports and refine the setup."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Professional Services?",
    "readyToDescription": "Book a demo and we will set up a proposal and referral workflow before the call."
  },
  {
    "id": 9,
    "icon": "IndustryIcon9",
    "name": "Education & Training Services",
    "description": "Enquiries, counselling, applications, enrolment and retention.",
    "setupHighlights": [
      "Enquiry-to-enrolment pipeline by programme and intake",
      "Application and fee reminders",
      "Follow-up for inactive or at-risk students"
    ],
    "intro": "Schools, colleges and training providers follow people from first enquiry through enrolment and beyond. GrowSquare is configured around programmes, intakes and the student journey.",
    "knowledge": "Enquiries come from campaigns, open days and referrals, and are often handled by counsellors who guide applicants through applications and fees. Retention depends on staying in touch with enrolled students. Training providers also sell to employers, which looks more like B2B sales.",
    "needs": [
      "Fast handling of enquiries by programme and intake",
      "Tracking applications, offers and fee payments",
      "Keeping in touch with enrolled students",
      "Selling training to employers alongside individual enrolments"
    ],
    "config": [
      {
        "title": "Pipeline stages",
        "items": [
          "Enquiry",
          "Counselling or consultation",
          "Application",
          "Offer",
          "Enrolment and payment",
          "Active student",
          "Alumni or re-enrolment"
        ]
      },
      {
        "title": "Records and fields",
        "items": [
          "Programme of interest and intake",
          "Enquiry source and counsellor",
          "Guardian or employer contact",
          "Application status and payment plan"
        ]
      },
      {
        "title": "Automation and approvals",
        "items": [
          "Enquiry assignment to counsellors",
          "Reminders for incomplete applications and fee payments",
          "Follow-up task when a student has had no contact for a set period",
          "Approval for scholarships or fee exceptions"
        ]
      },
      {
        "title": "Dashboards and reports",
        "items": [
          "Enquiry to enrolment by programme and source",
          "Intake targets against enrolments",
          "Counsellor workload and response time",
          "Retention by programme"
        ]
      }
    ],
    "scenario": {
      "situation": "A private college runs several intakes a year. Enquiries from campaigns and open days go into different spreadsheets and applications stall.",
      "setup": "We set up a programme and intake structure, assign enquiries to counsellors, send reminders for incomplete applications, and build a landing page for each programme with an A/B test.",
      "outcome": "Staff can see which sources lead to enrolments and which applications need a nudge."
    },
    "detailsFeatures": [
      {
        "title": "Intelligent Marketing & Asset Management",
        "description": "Programme landing pages, A/B tests and a library for brochures and course material"
      },
      {
        "title": "Customer Intelligence & Engagement",
        "description": "Tracks enquiries and follow-up"
      },
      {
        "title": "Intelligent Automation for Enhanced Customer Experience",
        "description": "Runs assignment and reminders"
      },
      {
        "title": "Advanced Business Intelligence",
        "description": "Reports on conversion, intakes and retention"
      }
    ],
    "detailsImplementation": [
      {
        "id": 1,
        "title": "Industry Assessment",
        "description": "Review programmes, intakes, the application process and student follow-up."
      },
      {
        "id": 2,
        "title": "Configuration",
        "description": "Set up programme records, stages, assignment rules and reminders."
      },
      {
        "id": 3,
        "title": "Team Training",
        "description": "Train admissions, marketing and student support teams."
      },
      {
        "id": 4,
        "title": "Ongoing Support",
        "description": "Review conversion and retention reports and adjust."
      }
    ],
    "readyToTitle": "Ready to See GrowSquare for Education and Training?",
    "readyToDescription": "Book a demo and we will set up programmes, intakes and an enquiry workflow before the call."
  }
];

export const integrations = [
  {
    id: 1,
    name: "Communication & Collaboration",
    features: ["Email Platforms", "Messaging & Chat", "Video Conferencing"],
    description: "Keeps customer and team conversations linked to the right record."
  },
  {
    id: 2,
    name: "Sales & Marketing",
    features: ["Marketing automation", "Sales automation", "Lead enrichment"],
    description: "Moves leads from campaign to sales without re-entering data."
  },
  {
    id: 3,
    name: "E-commerce & Payments",
    features: ["E-commerce platforms", "Payment gateways"],
    description: "Brings purchase and payment history into the customer record."
  },
  {
    id: 4,
    name: "ERP, Accounting & Finance",
    features: ["ERP platforms", "Accounting & invoicing"],
    description: "Keeps quotes, orders and invoices consistent between sales and finance."
  },
  {
    id: 5,
    name: "Customer Support & Engagement",
    features: ["Ticketing & support systems", "Live chat / chatbot platforms", "Social media & feedback"],
    description: "Shows support history next to the sales history."
  },
  {
    id: 6,
    name: "Analytics & Document Management",
    features: ["BI tools & data warehouses", "Cloud storage & document management", "Contract management / e-signature"],
    description: "Lets teams report on CRM data and find contracts and documents from the account."
  }
]
export const subscriptionPlans = [
  {
    id: 1,
    name: "Trial",
    price: "Free",
    duration: "21 days",
    description: "Experience the full power of GrowSquare with complete access to all features",
    highlights: [
      'Standard CRM Features',
      'Advanced AI-Powered Features',
      'Advanced Automation & Workflows',
      'Marketing & Case Management',
      'Sales Operations Management',
    ],
    features: [
      // All Professional features for trial
      "Core CRM Modules",
      "Customizable Views",
      "Personalized Dashboard",
      "Advanced Search & Filters",
      "Task Assignment & Tracking",
      "Notes & Activity Logs",
      "Document Storage & Management",
      "Bulk Data Updates",
      "Notifications & Reminders",
      "Data Import & Export Tools",
      "Record & Report Sharing",
      "Role-Based Access Control",
      "Product Catalog Management",
      "Services Management",
      "Staff Role Management with Multi-Country Rate Support",
      "Business Days Configuration",
      "Advanced Deal Tracking",
      "Kanban View for Leads and Deals",
      "Standard Reporting and Dashboard",
      "Integrated Email (Gmail, Outlook and others)",
      "Calendar Synchronization",
      "Integrated Calling (with twilio integration)",
      "Timeline View of Activities",
      "Quotation Management",
      "Sales Order Processing",
      "Invoice Management",
      "Invoice Payment - Stripe Integration",
      "Multi-Factor Authentication",
      "User, Group, and Role Management",
      "Linking of Emails and Calendar Activities",
      "ML powered intelligent Scoring",
      "Account Discovery Companion",
      "Account Intelligence Companion",
      "Intelligent Email Assistant",
      "Intelligent Deal Orchestration",
      "Genie - Sales Bot",
      "Sales Outreach Assistant",
      "Intelligent Lead Finder (with 3rd party integration)",
      "Advanced Revenue Forecasting",
      "Customer Case Management",
      "Intelligent Marketing Templates",
      "Digital Asset Manager",
      "Marketing Segmentation",
      "Marketing Campaign Management",
      "Advanced Workflow Automation",
      "Automated Assignment Rules",
      "Custom Approval Workflows",
      "Bulk Email Campaigns",
      "Sales Target & Goal Tracking",
      "Custom Email Templates",
      "Territory-Based Sales Management",
      "Advanced Reporting & Analytics",
      "Multi-Currency Support",
      // "Customize Modules",
      // "Customize Pipelines",
      "AI Tokens Allocated (1 Million/User)"
    ],
    highlight: false,
    buttonText: "Start Free Trial",
    buttonAction: "trial"
  },
  {
    id: 2,
    name: "Standard",
    price: "$29",
    priceAnnual: "$26",
    duration: "per user/month",
    description: "Perfect for growing teams with comprehensive CRM capabilities and essential business tools",
    highlights: [
      'Account Discovery Companion',
      'Account Intelligence Companion',
      'Intelligent Email Assistant',
      'Intelligent Deal Orchestration',
      'Genie - Sales Bot',
      'ML powered intelligent Scoring',
    ],
    features: [
      "ML powered intelligent Scoring",
      "Account Discovery Companion",
      "Account Intelligence Companion",
      "Intelligent Email Assistant",
      "Intelligent Deal Orchestration",
      "Genie - Sales Bot",
      "Core CRM Modules",
      "Customizable Views",
      "Personalized Dashboard",
      "Advanced Search & Filters",
      "Task Assignment & Tracking",
      "Notes & Activity Logs",
      "Document Storage & Management",
      "Bulk Data Updates",
      "Notifications & Reminders",
      "Data Import & Export Tools",
      "Record & Report Sharing",
      "Role-Based Access Control",
      "Product Catalog Management",
      "Services Management",
      "Staff Role Management with Multi-Country Rate Support",
      "Business Days Configuration",
      "Advanced Deal Tracking",
      "Kanban View for Leads and Deals",
      "Standard Reporting and Dashboard",
      "Integrated Email (Gmail, Outlook and others)",
      "Calendar Synchronization",
      "Integrated Calling (with twilio integration)",
      "Timeline View of Activities",
      "Quotation Management",
      "Sales Order Processing",
      "Invoice Management",
      "Invoice Payment - Stripe Integration",
      "Multi-Factor Authentication",
      "User, Group, and Role Management",
      "Linking of Emails and Calendar Activities",
      "AI Tokens Allocated (1 Million/User)"
    ],
    highlight: false,
    buttonText: "Subscribe Now",
    buttonAction: "checkout"
  },
  {
    id: 3,
    name: "Professional",
    price: "$59",
    priceAnnual: "$53",
    duration: "per user/month",
    description: "Advanced CRM with AI intelligence, automation, and enterprise-grade analytics for scaling businesses",
    highlights: [
      "Everything in Standard",
      'Sales Outreach Assistant',
      'Intelligent Lead Finder',
      'Intelligent Marketing Templates',
      'Advanced Revenue Forecasting',
      'Customer Case Management',
      'Advanced Workflow Automation',
    ],
    features: [
      "Sales Outreach Assistant",
      "Intelligent Lead Finder (with 3rd party integration)",
      "Advanced Revenue Forecasting",
      "Customer Case Management",
      "Intelligent Marketing Templates",
      "Digital Asset Manager",
      "Marketing Segmentation",
      "Marketing Campaign Management",
      "Advanced Workflow Automation",
      "Automated Assignment Rules",
      "Custom Approval Workflows",
      "Bulk Email Campaigns",
      "Sales Target & Goal Tracking",
      "Custom Email Templates",
      "Territory-Based Sales Management",
      "Advanced Reporting & Analytics",
      "Multi-Currency Support",
      "ML powered intelligent Scoring",
      "Account Discovery Companion",
      "Account Intelligence Companion",
      "Intelligent Email Assistant",
      "Intelligent Deal Orchestration",
      "Genie - Sales Bot",
      // "Customize Modules",
      // "Customize Pipelines",
      "Core CRM Modules",
      "Customizable Views",
      "Personalized Dashboard",
      "Advanced Search & Filters",
      "Task Assignment & Tracking",
      "Notes & Activity Logs",
      "Document Storage & Management",
      "Bulk Data Updates",
      "Notifications & Reminders",
      "Data Import & Export Tools",
      "Record & Report Sharing",
      "Role-Based Access Control",
      "Product Catalog Management",
      "Services Management",
      "Staff Role Management with Multi-Country Rate Support",
      "Business Days Configuration",
      "Advanced Deal Tracking",
      "Kanban View for Leads and Deals",
      "Standard Reporting and Dashboard",
      "Integrated Email (Gmail, Outlook and others)",
      "Calendar Synchronization",
      "Integrated Calling (with twilio integration)",
      "Timeline View of Activities",
      "Quotation Management",
      "Sales Order Processing",
      "Invoice Management",
      "Invoice Payment - Stripe Integration",
      "Multi-Factor Authentication",
      "User, Group, and Role Management",
      "Linking of Emails and Calendar Activities",
      "AI Tokens Allocated (5 Million/User)"
    ],
    highlight: true,
    buttonText: "Subscribe Now",
    buttonAction: "checkout"
  }
];
export const FAQList = [
  { question: "What’s included in the free trial?", answer: "The free trial includes full access to all features of the selected plan, so you can experience everything before subscribing." },
  { question: "How does the user-based pricing work?", answer: "Pricing is calculated per user, per month. You only pay for the number of active users in your team, and you can add or remove users anytime." },
  { question: "Do I need to sign a long-term contract?", answer: "No. You can choose monthly or yearly subscriptions. Yearly plans are still billed monthly but at a discounted rate." },
  { question: "Can I upgrade or downgrade my plan?", answer: "Yes, you can switch plans anytime. If you upgrade, you’ll be charged the prorated difference immediately. If you downgrade, the new plan will take effect from the next billing cycle." },
  { question: "What payment methods do you accept?", answer: "We currently support payments through major credit and debit cards only." },
  { question: "Can I cancel my subscription?", answer: "Yes. You can cancel at any time directly from your account settings. You’ll continue to have access until the end of the billing period." },
  { question: "Is support included in all plans?", answer: "Yes, all plans include standard support. Higher-tier plans also include priority support with faster response times." },
  { question: "How secure is my data?", answer: "All data is encrypted and stored in secure, enterprise-grade data centers with regular backups, ensuring compliance with industry standards." }
]
export const ProvenResult = {
  "title": "What We Customize",
  "description": "Customization usually covers the same five areas, whatever the sector.",
  "results": [
    {
      "title": "Sales Process and Stages",
      "subtitle": "Pipeline stages, entry criteria and next-step tasks that match how your team sells."
    },
    {
      "title": "Records and Fields",
      "subtitle": "Custom modules and fields for the things you track, such as properties, policies, programmes, products installed or contract terms."
    },
    {
      "title": "Automation and Approvals",
      "subtitle": "Lead assignment, reminders, escalations and approval rules for discounts, exceptions and contracts."
    },
    {
      "title": "Dashboards and Reports",
      "subtitle": "Role-specific views for reps, managers and leadership, using the measures your industry reports on."
    },
    {
      "title": "Roles and Access",
      "subtitle": "Role-based sharing so each team sees only the records it needs. Activity logs help support your own compliance processes."
    }
  ]
};

export const industryKnowledge = {
  "knowledgePoints": [
    {
      "title": "Industry Templates",
      "description": "Starting configurations for each sector that we adjust with you, rather than building from scratch."
    },
    {
      "title": "Specialized Integrations",
      "description": "Connections to sector tools such as e-commerce platforms, ERP and accounting, ticketing, and document management."
    },
    {
      "title": "Data Handling",
      "description": "Advice on which customer information belongs in the CRM and which should stay in your core systems, especially in regulated sectors."
    }
  ],
  "knowledgeCard": [
    {
      "icon": "IndustryIcon1",
      "title": "Information Technology & Software"
    },
    {
      "icon": "IndustryIcon8",
      "title": "Professional Services & Consulting"
    },
    {
      "icon": "IndustryIcon6",
      "title": "Retail & E-commerce"
    },
    {
      "icon": "IndustryIcon5",
      "title": "Manufacturing & Industrial Goods"
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Alex Chen",
    title: "Founder & CEO",
    company: "InnovateTech Startup",
    content: "GrowSquare's revolutionary approach gave us the edge we needed. Their AI doesn't just automate - it innovates alongside us.",
    rating: 5
  },
  {
    id: 2,
    name: "Maria Rodriguez",
    title: "Head of Growth",
    company: "NextGen Solutions",
    content: "As a startup, we needed something different. GrowSquare's fresh thinking and cutting-edge technology aligned perfectly with our vision.",
    rating: 5
  },
  {
    id: 3,
    name: "Jordan Kim",
    title: "Co-Founder",
    company: "FutureScale Inc.",
    content: "Finally, a CRM that thinks like a startup. Their predictive intelligence helped us identify opportunities we never knew existed.",
    rating: 5
  }
];
export const blogPosts = [
  {
    id: 1,
    title: "Trends, Insights, Effectiveness for IT Businesses",
    excerpt: "Customer relationship management (CRM) systems help companies build strong customer connections, organize customer data, improve communication, and streamline sales and service processes.Customer relationship management (CRM) systems help companies build strong customer connections, organize customer data, improve communication, and streamline sales and service processes.",
    author: "Cristina Matco",
    date: "2025-09-08",
    readTime: "7 min read",
    category: "Future Tech",
    link: "https://techbehemoths.com/blog/crm-trends-insights-effectiveness-survey-results"
  },
  {
    id: 2,
    title: "5 CRM Tech Trends to Shape the Future of Your Enterprise Organization",
    excerpt: "To make faster and more intelligent business decisions, close to 70% of organizations plan to continue or increase their investments in CRM technology in the coming year, according to Kate Leggett, Vice President and Principal Analyst at Forrester.",
    author: "Leigh Brown Perkins",
    date: "2025-03-20",
    readTime: "6 min read",
    category: "Startup Strategy",
    link: "https://blog.blackbaud.com/crm-tech-trends-to-shape-the-future-of-your-enterprise-organization/"
  },
  {
    id: 3,
    title: "how artificial intelligence is reshaping the future of customer relationship management",
    excerpt: "The relationship between businesses and their customers is undergoing a seismic transformation, and at the heart of this revolution is artificial intelligence (AI).",
    author: "Marcel Nannin",
    date: "2024-12-12",
    readTime: "7 min read",
    category: "Innovation",
    link: "https://www.crmreviews.com/insights/ai-and-crm"
  },
  {
    id: 4,
    title: "Artificial Intelligence in CRM: Benefits, Use Cases and Best Solutions",
    excerpt: "Customer relationship management (CRM) systems are evolving rapidly, driven by the integration of artificial intelligence (AI).",
    author: "Dmytro Sichkar",
    date: "2025-09-14",
    readTime: "14 min read",
    category: "Implementation",
    link: "https://djangostars.com/blog/ai-in-crm/"
  },
];
export const contactInfo = {
  addresses: [
    {
      office: "Innovation & Sales Hub",
      address: "457-459 Elizabeth St, Surry Hills, NSW 2010",
      city: "Australia",
      // phone: "+1 (555) 123-4567"
    },
    {
      office: "Delivery Center",
      address: "Kengeri Satellite Town, Bengaluru, Karnataka 560060",
      city: "India",
      // phone: "+1 (555) 987-6543"
    }
  ],
  email: {
    general: "hello@cxsquare.solutions"
    // general: "grow@cxsquare.solutions",
    // sales: "grow@cxsquare.solutions",
    // support: "innovate@cxsquare.com"
  },
  social: {
    // linkedin: "https://linkedin.com/company/cxsquare",
    // twitter: "https://twitter.com/cxsquare",
    // github: "https://github.com/cxsquare"
    linkedin: "/",
    twitter: "/",
    github: "/",
  }
};
export const FooterLinks = {
  productSection: [
    { id: 1, title: "Customer Intelligence & Engagement", },
    { id: 2, title: "Intelligent Deal Orchestration", },
    { id: 3, title: "ML-Powered Insights & Predictions", },
    { id: 4, title: "Advanced Sales Forecasting", },
    { id: 8, title: "Intelligent Marketing & Asset Management", },
    // { id: 6, title: "Customer Experience Personalization", }
  ],
  solutionSection: [
    { id: 7, title: "System Integration & CRM Migration", },
    { id: 8, title: "Tailored CRM Customization", },
    { id: 9, title: "Strategic CRM Services", },
    { id: 4, title: "Targeted Marketing Campaigns", },
    // { id: 1, title: "Sales Pipeline Optimization", }
  ]
}
export const PERSONAL_DOMAINS = new Set([
  'gmail.com', 'yahoo.com', 'yahoo.co.uk', 'yahoo.in', 'hotmail.com', 'hotmail.co.uk',
  'outlook.com', 'live.com', 'icloud.com', 'me.com', 'mac.com', 'aol.com',
  'protonmail.com', 'proton.me', 'zoho.com', 'yandex.com', 'yandex.ru',
  'mail.com', 'gmx.com', 'gmx.net', 'inbox.com', 'rediffmail.com', 'msn.com',
  'comcast.net', 'verizon.net', 'att.net', 'sbcglobal.net', 'bellsouth.net',
  'cox.net', 'charter.net', 'earthlink.net', 'optonline.net',
  // more personal mailbox providers (regional Yahoo / Hotmail / Outlook / Live variants such as
  // yahoo.com.au or outlook.com.au are also caught by a pattern in lib/formValidation.js)
  'googlemail.com', 'ymail.com', 'rocketmail.com', 'yahoo.com.au', 'yahoo.co.in', 'yahoo.ca', 'yahoo.fr', 'yahoo.de',
  'hotmail.com.au', 'hotmail.fr', 'hotmail.de', 'outlook.com.au', 'outlook.in', 'live.com.au', 'live.co.uk', 'live.in',
  'pm.me', 'tutanota.com', 'tuta.io', 'fastmail.com', 'hey.com', 'qq.com', '163.com', '126.com', 'sina.com',
  'naver.com', 'daum.net', 'web.de', 'mail.ru', 'bk.ru', 'list.ru', 'inbox.ru', 'bigpond.com', 'bigpond.net.au',
  'optusnet.com.au', 'ozemail.com.au', 'tpg.com.au', 'iinet.net.au', 'sky.com', 'btinternet.com', 'virginmedia.com',
  'talktalk.net', 'blueyonder.co.uk', 'sify.com',
  // disposable / temporary mailboxes
  'mailinator.com', 'guerrillamail.com', 'sharklasers.com', 'tempmail.com', '10minutemail.com', 'yopmail.com',
  'trashmail.com', 'getnada.com', 'maildrop.cc', 'dispostable.com', 'temp-mail.org', 'throwawaymail.com'
]);
export const COUNTRY_PHONE_RULES = [
  { keyId: 'AF', flag: '🇦🇫', name: 'Afghanistan', code: '93', min: 9, max: 9 },
  { keyId: 'AL', flag: '🇦🇱', name: 'Albania', code: '355', min: 9, max: 9 },
  { keyId: 'DZ', flag: '🇩🇿', name: 'Algeria', code: '213', min: 9, max: 9 },
  { keyId: 'AD', flag: '🇦🇩', name: 'Andorra', code: '376', min: 6, max: 9 },
  { keyId: 'AO', flag: '🇦🇴', name: 'Angola', code: '244', min: 9, max: 9 },
  { keyId: 'AG', flag: '🇦🇬', name: 'Antigua & Barbuda', code: '1', min: 10, max: 10 },
  { keyId: 'AR', flag: '🇦🇷', name: 'Argentina', code: '54', min: 10, max: 11 },
  { keyId: 'AM', flag: '🇦🇲', name: 'Armenia', code: '374', min: 8, max: 8 },
  { keyId: 'AU', flag: '🇦🇺', name: 'Australia', code: '61', min: 9, max: 9 },
  { keyId: 'AT', flag: '🇦🇹', name: 'Austria', code: '43', min: 10, max: 11 },
  { keyId: 'AZ', flag: '🇦🇿', name: 'Azerbaijan', code: '994', min: 9, max: 9 },
  { keyId: 'BS', flag: '🇧🇸', name: 'Bahamas', code: '1', min: 10, max: 10 },
  { keyId: 'BH', flag: '🇧🇭', name: 'Bahrain', code: '973', min: 8, max: 8 },
  { keyId: 'BD', flag: '🇧🇩', name: 'Bangladesh', code: '880', min: 10, max: 10 },
  { keyId: 'BB', flag: '🇧🇧', name: 'Barbados', code: '1', min: 10, max: 10 },
  { keyId: 'BY', flag: '🇧🇾', name: 'Belarus', code: '375', min: 9, max: 9 },
  { keyId: 'BE', flag: '🇧🇪', name: 'Belgium', code: '32', min: 9, max: 9 },
  { keyId: 'BZ', flag: '🇧🇿', name: 'Belize', code: '501', min: 7, max: 7 },
  { keyId: 'BJ', flag: '🇧🇯', name: 'Benin', code: '229', min: 8, max: 8 },
  { keyId: 'BT', flag: '🇧🇹', name: 'Bhutan', code: '975', min: 8, max: 8 },
  { keyId: 'BO', flag: '🇧🇴', name: 'Bolivia', code: '591', min: 8, max: 8 },
  { keyId: 'BA', flag: '🇧🇦', name: 'Bosnia & Herzegovina', code: '387', min: 8, max: 8 },
  { keyId: 'BW', flag: '🇧🇼', name: 'Botswana', code: '267', min: 8, max: 8 },
  { keyId: 'BR', flag: '🇧🇷', name: 'Brazil', code: '55', min: 10, max: 11 },
  { keyId: 'BN', flag: '🇧🇳', name: 'Brunei', code: '673', min: 7, max: 7 },
  { keyId: 'BG', flag: '🇧🇬', name: 'Bulgaria', code: '359', min: 9, max: 9 },
  { keyId: 'BF', flag: '🇧🇫', name: 'Burkina Faso', code: '226', min: 8, max: 8 },
  { keyId: 'BI', flag: '🇧🇮', name: 'Burundi', code: '257', min: 8, max: 8 },
  { keyId: 'CV', flag: '🇨🇻', name: 'Cape Verde', code: '238', min: 7, max: 7 },
  { keyId: 'KH', flag: '🇰🇭', name: 'Cambodia', code: '855', min: 8, max: 9 },
  { keyId: 'CM', flag: '🇨🇲', name: 'Cameroon', code: '237', min: 9, max: 9 },
  { keyId: 'CA', flag: '🇨🇦', name: 'Canada', code: '1', min: 10, max: 10 },
  { keyId: 'CF', flag: '🇨🇫', name: 'Central African Rep.', code: '236', min: 8, max: 8 },
  { keyId: 'TD', flag: '🇹🇩', name: 'Chad', code: '235', min: 8, max: 8 },
  { keyId: 'CL', flag: '🇨🇱', name: 'Chile', code: '56', min: 9, max: 9 },
  { keyId: 'CN', flag: '🇨🇳', name: 'China', code: '86', min: 11, max: 11 },
  { keyId: 'CO', flag: '🇨🇴', name: 'Colombia', code: '57', min: 10, max: 10 },
  { keyId: 'KM', flag: '🇰🇲', name: 'Comoros', code: '269', min: 7, max: 7 },
  { keyId: 'CG', flag: '🇨🇬', name: 'Congo', code: '242', min: 9, max: 9 },
  { keyId: 'CR', flag: '🇨🇷', name: 'Costa Rica', code: '506', min: 8, max: 8 },
  { keyId: 'HR', flag: '🇭🇷', name: 'Croatia', code: '385', min: 8, max: 9 },
  { keyId: 'CU', flag: '🇨🇺', name: 'Cuba', code: '53', min: 8, max: 8 },
  { keyId: 'CY', flag: '🇨🇾', name: 'Cyprus', code: '357', min: 8, max: 8 },
  { keyId: 'CZ', flag: '🇨🇿', name: 'Czech Republic', code: '420', min: 9, max: 9 },
  { keyId: 'DK', flag: '🇩🇰', name: 'Denmark', code: '45', min: 8, max: 8 },
  { keyId: 'DJ', flag: '🇩🇯', name: 'Djibouti', code: '253', min: 8, max: 8 },
  { keyId: 'DM', flag: '🇩🇲', name: 'Dominica', code: '1', min: 10, max: 10 },
  { keyId: 'DO', flag: '🇩🇴', name: 'Dominican Republic', code: '1', min: 10, max: 10 },
  { keyId: 'EC', flag: '🇪🇨', name: 'Ecuador', code: '593', min: 9, max: 9 },
  { keyId: 'EG', flag: '🇪🇬', name: 'Egypt', code: '20', min: 10, max: 10 },
  { keyId: 'SV', flag: '🇸🇻', name: 'El Salvador', code: '503', min: 8, max: 8 },
  { keyId: 'GQ', flag: '🇬🇶', name: 'Equatorial Guinea', code: '240', min: 9, max: 9 },
  { keyId: 'ER', flag: '🇪🇷', name: 'Eritrea', code: '291', min: 7, max: 7 },
  { keyId: 'EE', flag: '🇪🇪', name: 'Estonia', code: '372', min: 7, max: 8 },
  { keyId: 'SZ', flag: '🇸🇿', name: 'Eswatini', code: '268', min: 8, max: 8 },
  { keyId: 'ET', flag: '🇪🇹', name: 'Ethiopia', code: '251', min: 9, max: 9 },
  { keyId: 'FJ', flag: '🇫🇯', name: 'Fiji', code: '679', min: 7, max: 7 },
  { keyId: 'FI', flag: '🇫🇮', name: 'Finland', code: '358', min: 9, max: 11 },
  { keyId: 'FR', flag: '🇫🇷', name: 'France', code: '33', min: 9, max: 9 },
  { keyId: 'GA', flag: '🇬🇦', name: 'Gabon', code: '241', min: 8, max: 8 },
  { keyId: 'GM', flag: '🇬🇲', name: 'Gambia', code: '220', min: 7, max: 7 },
  { keyId: 'GE', flag: '🇬🇪', name: 'Georgia', code: '995', min: 9, max: 9 },
  { keyId: 'DE', flag: '🇩🇪', name: 'Germany', code: '49', min: 10, max: 11 },
  { keyId: 'GH', flag: '🇬🇭', name: 'Ghana', code: '233', min: 9, max: 9 },
  { keyId: 'GR', flag: '🇬🇷', name: 'Greece', code: '30', min: 10, max: 10 },
  { keyId: 'GD', flag: '🇬🇩', name: 'Grenada', code: '1', min: 10, max: 10 },
  { keyId: 'GT', flag: '🇬🇹', name: 'Guatemala', code: '502', min: 8, max: 8 },
  { keyId: 'GN', flag: '🇬🇳', name: 'Guinea', code: '224', min: 9, max: 9 },
  { keyId: 'GW', flag: '🇬🇼', name: 'Guinea-Bissau', code: '245', min: 7, max: 7 },
  { keyId: 'GY', flag: '🇬🇾', name: 'Guyana', code: '592', min: 7, max: 7 },
  { keyId: 'HT', flag: '🇭🇹', name: 'Haiti', code: '509', min: 8, max: 8 },
  { keyId: 'HN', flag: '🇭🇳', name: 'Honduras', code: '504', min: 8, max: 8 },
  { keyId: 'HU', flag: '🇭🇺', name: 'Hungary', code: '36', min: 9, max: 9 },
  { keyId: 'IS', flag: '🇮🇸', name: 'Iceland', code: '354', min: 7, max: 7 },
  { keyId: 'IN', flag: '🇮🇳', name: 'India', code: '91', min: 10, max: 10 },
  { keyId: 'ID', flag: '🇮🇩', name: 'Indonesia', code: '62', min: 9, max: 12 },
  { keyId: 'IR', flag: '🇮🇷', name: 'Iran', code: '98', min: 10, max: 10 },
  { keyId: 'IQ', flag: '🇮🇶', name: 'Iraq', code: '964', min: 10, max: 10 },
  { keyId: 'IE', flag: '🇮🇪', name: 'Ireland', code: '353', min: 9, max: 9 },
  { keyId: 'IL', flag: '🇮🇱', name: 'Israel', code: '972', min: 9, max: 9 },
  { keyId: 'IT', flag: '🇮🇹', name: 'Italy', code: '39', min: 9, max: 11 },
  { keyId: 'JM', flag: '🇯🇲', name: 'Jamaica', code: '1', min: 10, max: 10 },
  { keyId: 'JP', flag: '🇯🇵', name: 'Japan', code: '81', min: 10, max: 10 },
  { keyId: 'JO', flag: '🇯🇴', name: 'Jordan', code: '962', min: 9, max: 9 },
  { keyId: 'KZ', flag: '🇰🇿', name: 'Kazakhstan', code: '7', min: 10, max: 10 },
  { keyId: 'KE', flag: '🇰🇪', name: 'Kenya', code: '254', min: 9, max: 9 },
  { keyId: 'KI', flag: '🇰🇮', name: 'Kiribati', code: '686', min: 5, max: 5 },
  { keyId: 'KW', flag: '🇰🇼', name: 'Kuwait', code: '965', min: 8, max: 8 },
  { keyId: 'KG', flag: '🇰🇬', name: 'Kyrgyzstan', code: '996', min: 9, max: 9 },
  { keyId: 'LA', flag: '🇱🇦', name: 'Laos', code: '856', min: 8, max: 9 },
  { keyId: 'LV', flag: '🇱🇻', name: 'Latvia', code: '371', min: 8, max: 8 },
  { keyId: 'LB', flag: '🇱🇧', name: 'Lebanon', code: '961', min: 7, max: 8 },
  { keyId: 'LS', flag: '🇱🇸', name: 'Lesotho', code: '266', min: 8, max: 8 },
  { keyId: 'LR', flag: '🇱🇷', name: 'Liberia', code: '231', min: 7, max: 8 },
  { keyId: 'LY', flag: '🇱🇾', name: 'Libya', code: '218', min: 9, max: 9 },
  { keyId: 'LI', flag: '🇱🇮', name: 'Liechtenstein', code: '423', min: 7, max: 9 },
  { keyId: 'LT', flag: '🇱🇹', name: 'Lithuania', code: '370', min: 8, max: 8 },
  { keyId: 'LU', flag: '🇱🇺', name: 'Luxembourg', code: '352', min: 9, max: 9 },
  { keyId: 'MG', flag: '🇲🇬', name: 'Madagascar', code: '261', min: 9, max: 9 },
  { keyId: 'MW', flag: '🇲🇼', name: 'Malawi', code: '265', min: 9, max: 9 },
  { keyId: 'MY', flag: '🇲🇾', name: 'Malaysia', code: '60', min: 9, max: 10 },
  { keyId: 'MV', flag: '🇲🇻', name: 'Maldives', code: '960', min: 7, max: 7 },
  { keyId: 'ML', flag: '🇲🇱', name: 'Mali', code: '223', min: 8, max: 8 },
  { keyId: 'MT', flag: '🇲🇹', name: 'Malta', code: '356', min: 8, max: 8 },
  { keyId: 'MH', flag: '🇲🇭', name: 'Marshall Islands', code: '692', min: 7, max: 7 },
  { keyId: 'MR', flag: '🇲🇷', name: 'Mauritania', code: '222', min: 8, max: 8 },
  { keyId: 'MU', flag: '🇲🇺', name: 'Mauritius', code: '230', min: 8, max: 8 },
  { keyId: 'MX', flag: '🇲🇽', name: 'Mexico', code: '52', min: 10, max: 10 },
  { keyId: 'FM', flag: '🇫🇲', name: 'Micronesia', code: '691', min: 7, max: 7 },
  { keyId: 'MD', flag: '🇲🇩', name: 'Moldova', code: '373', min: 8, max: 8 },
  { keyId: 'MC', flag: '🇲🇨', name: 'Monaco', code: '377', min: 8, max: 9 },
  { keyId: 'MN', flag: '🇲🇳', name: 'Mongolia', code: '976', min: 8, max: 8 },
  { keyId: 'ME', flag: '🇲🇪', name: 'Montenegro', code: '382', min: 8, max: 8 },
  { keyId: 'MA', flag: '🇲🇦', name: 'Morocco', code: '212', min: 9, max: 9 },
  { keyId: 'MZ', flag: '🇲🇿', name: 'Mozambique', code: '258', min: 9, max: 9 },
  { keyId: 'MM', flag: '🇲🇲', name: 'Myanmar', code: '95', min: 8, max: 10 },
  { keyId: 'NA', flag: '🇳🇦', name: 'Namibia', code: '264', min: 9, max: 9 },
  { keyId: 'NR', flag: '🇳🇷', name: 'Nauru', code: '674', min: 7, max: 7 },
  { keyId: 'NP', flag: '🇳🇵', name: 'Nepal', code: '977', min: 10, max: 10 },
  { keyId: 'NL', flag: '🇳🇱', name: 'Netherlands', code: '31', min: 9, max: 9 },
  { keyId: 'NZ', flag: '🇳🇿', name: 'New Zealand', code: '64', min: 8, max: 9 },
  { keyId: 'NI', flag: '🇳🇮', name: 'Nicaragua', code: '505', min: 8, max: 8 },
  { keyId: 'NE', flag: '🇳🇪', name: 'Niger', code: '227', min: 8, max: 8 },
  { keyId: 'NG', flag: '🇳🇬', name: 'Nigeria', code: '234', min: 10, max: 10 },
  { keyId: 'NO', flag: '🇳🇴', name: 'Norway', code: '47', min: 8, max: 8 },
  { keyId: 'OM', flag: '🇴🇲', name: 'Oman', code: '968', min: 8, max: 8 },
  { keyId: 'PK', flag: '🇵🇰', name: 'Pakistan', code: '92', min: 10, max: 10 },
  { keyId: 'PW', flag: '🇵🇼', name: 'Palau', code: '680', min: 7, max: 7 },
  { keyId: 'PA', flag: '🇵🇦', name: 'Panama', code: '507', min: 8, max: 8 },
  { keyId: 'PG', flag: '🇵🇬', name: 'Papua New Guinea', code: '675', min: 8, max: 8 },
  { keyId: 'PY', flag: '🇵🇾', name: 'Paraguay', code: '595', min: 9, max: 9 },
  { keyId: 'PE', flag: '🇵🇪', name: 'Peru', code: '51', min: 9, max: 9 },
  { keyId: 'PH', flag: '🇵🇭', name: 'Philippines', code: '63', min: 10, max: 10 },
  { keyId: 'PL', flag: '🇵🇱', name: 'Poland', code: '48', min: 9, max: 9 },
  { keyId: 'PT', flag: '🇵🇹', name: 'Portugal', code: '351', min: 9, max: 9 },
  { keyId: 'QA', flag: '🇶🇦', name: 'Qatar', code: '974', min: 8, max: 8 },
  { keyId: 'RO', flag: '🇷🇴', name: 'Romania', code: '40', min: 9, max: 9 },
  { keyId: 'RU', flag: '🇷🇺', name: 'Russia', code: '7', min: 10, max: 10 },
  { keyId: 'RW', flag: '🇷🇼', name: 'Rwanda', code: '250', min: 9, max: 9 },
  { keyId: 'KN', flag: '🇰🇳', name: 'Saint Kitts & Nevis', code: '1', min: 10, max: 10 },
  { keyId: 'LC', flag: '🇱🇨', name: 'Saint Lucia', code: '1', min: 10, max: 10 },
  { keyId: 'VC', flag: '🇻🇨', name: 'Saint Vincent', code: '1', min: 10, max: 10 },
  { keyId: 'WS', flag: '🇼🇸', name: 'Samoa', code: '685', min: 5, max: 7 },
  { keyId: 'SM', flag: '🇸🇲', name: 'San Marino', code: '378', min: 6, max: 10 },
  { keyId: 'ST', flag: '🇸🇹', name: 'Sao Tome & Principe', code: '239', min: 7, max: 7 },
  { keyId: 'SA', flag: '🇸🇦', name: 'Saudi Arabia', code: '966', min: 9, max: 9 },
  { keyId: 'SN', flag: '🇸🇳', name: 'Senegal', code: '221', min: 9, max: 9 },
  { keyId: 'RS', flag: '🇷🇸', name: 'Serbia', code: '381', min: 8, max: 9 },
  { keyId: 'SC', flag: '🇸🇨', name: 'Seychelles', code: '248', min: 7, max: 7 },
  { keyId: 'SL', flag: '🇸🇱', name: 'Sierra Leone', code: '232', min: 8, max: 8 },
  { keyId: 'SG', flag: '🇸🇬', name: 'Singapore', code: '65', min: 8, max: 8 },
  { keyId: 'SK', flag: '🇸🇰', name: 'Slovakia', code: '421', min: 9, max: 9 },
  { keyId: 'SI', flag: '🇸🇮', name: 'Slovenia', code: '386', min: 8, max: 8 },
  { keyId: 'SB', flag: '🇸🇧', name: 'Solomon Islands', code: '677', min: 7, max: 7 },
  { keyId: 'SO', flag: '🇸🇴', name: 'Somalia', code: '252', min: 8, max: 9 },
  { keyId: 'ZA', flag: '🇿🇦', name: 'South Africa', code: '27', min: 9, max: 9 },
  { keyId: 'SS', flag: '🇸🇸', name: 'South Sudan', code: '211', min: 9, max: 9 },
  { keyId: 'ES', flag: '🇪🇸', name: 'Spain', code: '34', min: 9, max: 9 },
  { keyId: 'LK', flag: '🇱🇰', name: 'Sri Lanka', code: '94', min: 9, max: 9 },
  { keyId: 'SD', flag: '🇸🇩', name: 'Sudan', code: '249', min: 9, max: 9 },
  { keyId: 'SR', flag: '🇸🇷', name: 'Suriname', code: '597', min: 7, max: 7 },
  { keyId: 'SE', flag: '🇸🇪', name: 'Sweden', code: '46', min: 9, max: 9 },
  { keyId: 'CH', flag: '🇨🇭', name: 'Switzerland', code: '41', min: 9, max: 9 },
  { keyId: 'SY', flag: '🇸🇾', name: 'Syria', code: '963', min: 9, max: 9 },
  { keyId: 'TW', flag: '🇹🇼', name: 'Taiwan', code: '886', min: 9, max: 9 },
  { keyId: 'TJ', flag: '🇹🇯', name: 'Tajikistan', code: '992', min: 9, max: 9 },
  { keyId: 'TZ', flag: '🇹🇿', name: 'Tanzania', code: '255', min: 9, max: 9 },
  { keyId: 'TH', flag: '🇹🇭', name: 'Thailand', code: '66', min: 9, max: 9 },
  { keyId: 'TL', flag: '🇹🇱', name: 'Timor-Leste', code: '670', min: 7, max: 8 },
  { keyId: 'TG', flag: '🇹🇬', name: 'Togo', code: '228', min: 8, max: 8 },
  { keyId: 'TO', flag: '🇹🇴', name: 'Tonga', code: '676', min: 5, max: 7 },
  { keyId: 'TT', flag: '🇹🇹', name: 'Trinidad & Tobago', code: '1', min: 10, max: 10 },
  { keyId: 'TN', flag: '🇹🇳', name: 'Tunisia', code: '216', min: 8, max: 8 },
  { keyId: 'TR', flag: '🇹🇷', name: 'Turkey', code: '90', min: 10, max: 10 },
  { keyId: 'TM', flag: '🇹🇲', name: 'Turkmenistan', code: '993', min: 8, max: 8 },
  { keyId: 'TV', flag: '🇹🇻', name: 'Tuvalu', code: '688', min: 5, max: 6 },
  { keyId: 'UG', flag: '🇺🇬', name: 'Uganda', code: '256', min: 9, max: 9 },
  { keyId: 'UA', flag: '🇺🇦', name: 'Ukraine', code: '380', min: 9, max: 9 },
  { keyId: 'AE', flag: '🇦🇪', name: 'UAE', code: '971', min: 9, max: 9 },
  { keyId: 'GB', flag: '🇬🇧', name: 'United Kingdom', code: '44', min: 10, max: 10 },
  { keyId: 'US', flag: '🇺🇸', name: 'USA', code: '1', min: 10, max: 10 },
  { keyId: 'UY', flag: '🇺🇾', name: 'Uruguay', code: '598', min: 9, max: 9 },
  { keyId: 'UZ', flag: '🇺🇿', name: 'Uzbekistan', code: '998', min: 9, max: 9 },
  { keyId: 'VU', flag: '🇻🇺', name: 'Vanuatu', code: '678', min: 7, max: 7 },
  { keyId: 'VE', flag: '🇻🇪', name: 'Venezuela', code: '58', min: 10, max: 10 },
  { keyId: 'VN', flag: '🇻🇳', name: 'Vietnam', code: '84', min: 9, max: 10 },
  { keyId: 'YE', flag: '🇾🇪', name: 'Yemen', code: '967', min: 9, max: 9 },
  { keyId: 'ZM', flag: '🇿🇲', name: 'Zambia', code: '260', min: 9, max: 9 },
  { keyId: 'ZW', flag: '🇿🇼', name: 'Zimbabwe', code: '263', min: 9, max: 9 },
];